import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import React from "react";
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from "react-pro-sidebar";
import {
  COMPLIANCE_APPROVED,
  COMPLIANCE_NEW,
  COMPLIANCE_PENDING,
  COMPLIANCE_REJECTED,
  INVESTOR_TYPE_COMPANY,
  INVESTOR_TYPE_INDIVIDUAL,
  base_url,
} from "../utilities";
import { useForm } from "react-hook-form";
import moment from "moment";
import { ThreeDots } from "react-loader-spinner";

import axios from "axios";
import Cookies from 'js-cookie';
import InvestorSideNavBar from "./SideNavBarInvestor";
import InvestorNavBarMain from "./InvestorNavBar";
import { toast } from "react-toastify";
import { BusinessSettings } from "../BusinessFlow/BusinessSettings";

import SideNavBarInvestorKYC from "./SideNavBarInvestorKYC";
import InvestorContactDetails from "./InvestorContactDetails";
import InvestorPersonalDetails from "./InvestorPersonalDetails";
import InvestorIdentityVerification from "./InvestorIdentityVerification";
import InvestorSelfieCapture from "./InvestorSelfieCapture";
import InvestorReviewDetails from "./InvestorReviewDetails";
import ProgressBar from "./ProgressBar";
import { LOADER, LOADING, HIDING } from "../Constant";
import { GlobalLoader } from "../helpers";
import { EKYC_BASE_URL } from "../config/environment";

const InvestorKYCFlow = () => {

  const contentRef = useRef(null);
  const navigate = useNavigate();


  const { collapseSidebar, collapsed } = useProSidebar(false);
  const [investorDatauser, setInvestorDatauser] = useState([]);

  const [defaultvalue] = useState();
  const [download, setDownload] = useState([]);
  const [getDocuments, setGetDocuments] = useState([])
  const [others, setOthers] = useState([]);
  const [preOthers, setPreOthers] = useState([])
  const [deletedDoc, setDeletedDoc] = useState([])
  const [statusFlag, setStatusFlag] = useState(null)
  const [currentStep, setCurrentStep] = useState(null);

  const [completedSteps, setCompletedSteps] = useState([]);
  const [bankStatementError, setBankStatementError] = useState(false);
  const [identityError, setIdentityError] = useState(
    {
      id1Front: false,
      id1Back: false,
      id2Front: false,
      id2Back: false
    });

  const [validateErrors, setValidateErrors] = useState({
    name: false,
    phone: false,
    country: false,
    nationality: false
  });

  const [validatePersonalErrors, setValidatePersonalErrors] = useState({
    name: false,
    country: false,
    country_of_residence: false,
    nationality: false,
    sourse_of_fund: false,
    name_of_employer: false,
    committed_principal: false,
    nominee_name: false,
    nominee_dob: false,
    nominee_contact: false,
    nominee_relationship: false,
    guardian_name: false,
    guardian_dob: false,
    guardian_address: false,
    is_pep: false,
  });

  const [validateIdErrors, setValidateIdErrors] = useState({
    idType1: false,
    idType2: false,

  });
  const [enableSweetAlert, setEnableSweetAlert] = useState(null);
  const [isSelfieDone, setIsSelfieDone] = useState(false);
  const [showSelfieModal, setShowSelfieModal] = useState(false);

  const [selfieData, setSelfieData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState({})
  const [livenessSessionId, setLivenessSessionId] = useState(null)
  const [draftLoaded, setDraftLoaded] = useState(false)
  const [isKycReady, setIsKycReady] = useState(false);
  const [showInvestorSidebar, setShowInvestorSidebar] = useState(false);
  const [draftFiles, setDraftFiles] = useState({});


  const getLoadingAlert = (type) => {
    if (type === LOADING) {
      setEnableSweetAlert(true);
    } else {
      setEnableSweetAlert(false);
    }
  };


  const goToNextStep = (nextStep) => {
    setCompletedSteps((prev) => {
      const updated = Array.from(
        new Set([...prev, currentStep])
      ).sort((a, b) => a - b);

      sessionStorage.setItem(
        "kyc_completed_steps",
        JSON.stringify(updated)
      );
      return updated;
    });

    sessionStorage.setItem("kyc_current_step", nextStep);
    setCurrentStep(nextStep);
  };



  const goToPreviousStep = (prevStep) => {
    sessionStorage.setItem("kyc_current_step", prevStep);
    setCurrentStep(prevStep);
    // loadDraftClick();
  };


  const removeCompletedStep = (step) => {
    setCompletedSteps((prev) => {
      const updated = prev.filter((s) => s !== step);
      sessionStorage.setItem(
        "kyc_completed_steps",
        JSON.stringify(updated)
      );

      return updated;
    });
  };


  const kycExpiryDate = investorDatauser?.kyc?.[0]?.kyc_expiry_date;

  const isKycExpiry =
    kycExpiryDate && new Date(kycExpiryDate) < new Date();


  useEffect(() => {
    if (statusFlag == null) {
      getLoadingAlert(LOADING);
      return;
    }

    getLoadingAlert(LOADING);

    // ----- read sessionStorage safely -----
    const savedCompleted = JSON.parse(
      sessionStorage.getItem("kyc_completed_steps") || "[]"
    );

    const rawSavedStep = sessionStorage.getItem("kyc_current_step");
    const savedStep =
      rawSavedStep !== null ? Number(rawSavedStep) : null;

    setCompletedSteps(savedCompleted);

    const saveAsDraft = investorDatauser?.kyc?.[0]?.save_as_draft;

    // ----- STEP RESOLUTION (single source of truth) -----

    //  Valid saved step → trust it
    if (savedStep && savedStep > 0) {
      setCurrentStep(savedStep);
      setIsKycReady(true);
      getLoadingAlert(HIDING);
      return;
    }

    //  New KYC → start from step 1
    if (statusFlag === COMPLIANCE_NEW) {
      setCurrentStep(1);
      setIsKycReady(true);
      getLoadingAlert(HIDING);
      return;
    }

    if (saveAsDraft === 0 && statusFlag === COMPLIANCE_PENDING) {

      setCurrentStep(0);

      setIsKycReady(true);
      getLoadingAlert(HIDING);
      return;
    }

    const pageFromCookie = Cookies.get("kyc_currentPage");
   

    if (pageFromCookie === "1") {

      setCurrentStep(1);
      setIsKycReady(true);
      getLoadingAlert(HIDING);
      // Cookies.remove("kyc_currentPage");
      return;
    }
    else if (saveAsDraft === 0 && statusFlag === COMPLIANCE_APPROVED && pageFromCookie != "1") {

      setCurrentStep(5);
      setShowInvestorSidebar(true);
      setIsKycReady(true);
      getLoadingAlert(HIDING);
      return;
    }

    if (saveAsDraft === 0 && statusFlag === COMPLIANCE_REJECTED) {

      setCurrentStep(5);
      setIsKycReady(true);
      getLoadingAlert(HIDING);
      return;
    }

    setCurrentStep(1);
    setIsKycReady(true);
    getLoadingAlert(HIDING);

  }, [statusFlag, investorDatauser]);


  useEffect(() => {
    contentRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [currentStep]);


  const currentYear = new Date().getFullYear();
  const pastYears = new Date().getFullYear() - 123;

  const startYear = pastYears;
  const endYear = currentYear;
  const years = [];

  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  useEffect(() => {
    setDeletedDoc([]);
  }, [])
  useEffect(() => {
    setOthers(preOthers);
  }, [preOthers])
  useEffect(() => {
    if (Array.isArray(getDocuments?.kyc_documents)) {
      const filteredDocs = getDocuments.kyc_documents.filter((doc) => {
        return doc.document_type.includes("Others");
      });
      setPreOthers(filteredDocs);
    }
  }, [getDocuments]);

  const [updatedCustomers, setUpdatedCustomers] = useState([]);
  const [rejectedCustomers, setRejectedCustomers] = useState([]);
  const [companyFormData, setCompanyFormData] = useState({
    "investor_id": "",
    "investor_kyc_id": "",
    "user_id": "",
    "registered_address": "",
    "phone": "",
    "sector": "",
    "type": "",
    "investor_company_type": "",
    "investor_company_name": "",
    "country": "",
    "trade_license_no": "",
    "trade_license_expiry_date": "",
    "place_of_incorporation": "",
    "date_of_incorporation": "",
    "description_of_business": "",
    "beneficial_owner_with_percentage_holding": "",
    "shareholders": "",
    "products_by_the_company": "",
    "origin_of_products": "",
    "import_countries_with_percentage": "",
    "export_countries_with_percentage": "",
    "re_export_countries_with_percentage": "",
    "top_5_customers": "",
    "top_5_suppliers": "",
    "committed_principal": "",
    "no_of_full_time_employees": "",
    "is_pep": ""
  });
  useEffect(() => (
    setCompanyFormData(masterInvestorData)
  ), [investorDatauser])



  const [indivInvFormData, setIndivInvFormData] = useState(
    {
      "investor_id": "",
      "investor_kyc_id": "",
      "user_id": "",
      "gender": "",
      "investor_company_name":"",
      "phone": "",
      "registered_address": "",
      "nationality": "",
      "country": "",
      "home_country_contact": "",
      "country_of_birth": "",
      "date_of_birth": "",
      "passport_number": "",
      "passport_expiry_date": "",
      "description_of_income": "",
      "sourse_of_fund": "",
      "nominee_details": "",
      "nominee_name": "",
      "nominee_dob": "",
      "nominee_contact": "",
      "nominee_address": "",
      "nominee_relationship": "",
      "guardian_name": "",
      "guardian_dob": "",
      "guardian_address": "",
      "investor_name": "",
      "name_of_employer": "",
      "country_of_employer": "",
      "national_id": "",
      "other_passport_details": "",
      "committed_principal": "",
      "created_by": Cookies.get("Inv_login_user"),
      "is_pep": "",
      "bankStatementFile": "",
      "bank_statement_blob_url": "",
      "bank_statement_file_name": "",
      "addressProofFile": "",
      "address_proof_blob_url": "",
      "address_proof_file_name": "",
      'idType1': "",
      'idType2': "",
      "id1Front": "",
      "id1Back": "",
      "id1FrontBlobUrl": "",
      "id1BackBlobUrl": "",
      "id1FrontName": "",
      "id1BackName": "",
      'id2Front': '',
      'id2Back': '',
      'id2FrontBlobUrl': '',
      'id2BackBlobUrl': '',
      'id2FrontName': '',
      'id2BackName': '',
      "selfieImage": "",
      "livenessVideo": "",
      "livenessSessionId": "",
      "selfie_blob_name": "",
      "selfie_blob_url": "",
      "liveness_video_blob_name": "",
      "liveness_video_blob_url": ""


    }
  );



  useEffect(() => {
    const saved = localStorage.getItem(`indivInvData_${investorDatauser?.user_id}`);

    if (saved) {
      setIndivInvFormData(JSON.parse(saved));
    }


  }, []);

  const handleChangeDownloadForOthers = (event, file, doc) => {

    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
    }
    else {
      if (file.document_url && typeof file.document_url === 'string') {
        window.open(file.document_url, '_blank');
      }
    }
  }


  const handleDownloadKycFiles = (event, file) => {
    event?.preventDefault?.();

    // Case 1: Newly uploaded file
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");

      // cleanup
      setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
      return;
    }

    // Case 2: Backend / restored file (blob URL)
    if (file?.blobUrl && typeof file.blobUrl === "string") {
      window.open(file.blobUrl, "_blank");
      return;
    }

    // Case 3: Backend document format (fallback)
    if (file?.document_url && typeof file.document_url === "string") {
      window.open(file.document_url, "_blank");
      return;
    }

    console.warn("No valid file or URL to open", file);
  };


  const handleDeleteClickOthers = (item) => {
    let updatedOthers;
    if (item instanceof File) {
      updatedOthers = others.filter((doc) => doc.name !== item.name);
    } else {
      updatedOthers = others.filter((doc) => doc.document_type !== item.document_type);
    }
    setOthers(updatedOthers);
    if (preOthers.length > 0 && !(item instanceof File))
      handleDeleteDocForOthers(item);
  };

  const handleDeleteDocForOthers = (item) => {
    setDeletedDoc(prevItems => [...prevItems, item.document_id]);
  }
  const [updatedSuppliers, setUpdatedSuppliers] = useState([]);
  const [rejectedSuppliers, setRejectedSuppliers] = useState([]);
  const [updatedBanks, setUpdatedBanks] = useState([]);
  const [rejectedBanks, setRejectedBanks] = useState([]);

  const [rejectedFlag, setRejectedFlag] = useState(true);
  const [rejectedInvDetails, setRejectedInvDetails] = useState()
  const [livenessErrorMsg, setLivenessErrorMsg] = useState("");

  // Fnction to calculate age 
  const calculateAge = (dob) => {
    if (!dob) return null;

    let birthDate;

    if (dob instanceof Date) {
      birthDate = dob;
    } else if (typeof dob === "number") {
      birthDate = new Date(dob);
    } else if (typeof dob === "string") {
      const [day, month, year] = dob.split("-");
      birthDate = new Date(year, month - 1, day);
    } else {
      return null;
    }

    if (isNaN(birthDate.getTime())) return null;
    if (birthDate > new Date()) return null; // 🔒 important

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  const nomineeDob = indivInvFormData?.nominee_dob
    ? new Date(indivInvFormData?.nominee_dob)
    : null;

  const nomineeAge = calculateAge(nomineeDob);
  const isMinor = nomineeAge !== null && nomineeAge < 18;

  const fetchInvestorMaster = async () => {
    getLoadingAlert(LOADING);
    try {
      const res = await axios.post(
        base_url + "investor-master/get_investor_master_user",
        { user_id: Cookies.get("investor_user_id") }
      );

      getLoadingAlert(HIDING);
      const data = res.data.data;
      setInvestorDatauser(data);

      return data;
    } catch (err) {
      getLoadingAlert(HIDING);
      console.error(
        "Error fetching investor master user:",
        err.response || err.message
      );
      throw err;
    }
  };



  useEffect(() => {
    if (!Cookies.get("User_Accesstoken")) {
      navigate("/");
    }
    getLoadingAlert(LOADING);
    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
        getLoadingAlert(HIDING)
        let data = res.data.data
        setInvestorDatauser(data);

        if (res.data.data.kyc?.length === 0) {
          sessionStorage.setItem("kyc_current_step", 1);
          sessionStorage.setItem("kyc_completed_steps", JSON.stringify([]));

          setCurrentStep(1);
          setCompletedSteps([]);
        }


        if (res.data.data.kyc?.length === 0 || res.data.data.kyc[0]?.status != COMPLIANCE_APPROVED) {
          Cookies.set("kyc_status", 0, { expires: 7 })
        } else {
          Cookies.set("kyc_status", 2, { expires: 7 })
        }



        setCompanyFormData(prev => ({
          ...prev,
          phone: data?.phone,
          investor_company_name: data?.investor_company_name,
          type: data?.type,
          user_id: data.user_id,
          investor_id: data.investor_id,
          country: data?.country == "undefined" ? '' : data?.country,

        }))






        setIndivInvFormData(prev => {

          const saved = localStorage.getItem(`indivInvData_${investorDatauser?.user_id}`)
          const localData = saved ? JSON.parse(saved) : {};



          const getValue = (localVal, apiVal) =>
            localVal ? localVal : (apiVal || "");



          const finalData = {
            ...prev,
            ...data,

            investor_name: getValue(localData.investor_name, data.investor_name),
            phone: getValue(localData.phone, data.phone),
            email: getValue(localData.email, data.email),
            date_of_birth: getValue(localData.date_of_birth, data.date_of_birth),
            country: getValue(localData.country, data.country),
            nationality: getValue(localData.nationality, data.nationality),
            country_of_residence: getValue(localData.country_of_residence, data.country_of_residence),
            name_of_employer: getValue(localData.name_of_employer, data.name_of_employer),
            sourse_of_fund: getValue(localData.sourse_of_fund, data.sourse_of_fund),
            committed_principal: getValue(localData.committed_principal, data.committed_principal),
            gender: getValue(localData.gender, data.gender),
            investor_company_name: getValue(localData.investor_company_name, data.investor_company_name),

            nominee_name: getValue(localData.nominee_name, data.nominee_name),
            nominee_relationship: getValue(localData.nominee_relationship, data.nominee_relationship),
            nominee_dob: getValue(localData.nominee_dob, data.nominee_dob),
            nominee_contact: getValue(localData.nominee_contact, data.nominee_contact),

            guardian_name: getValue(localData.guardian_name, data.guardian_name),
            guardian_address: getValue(localData.guardian_address, data.guardian_address),
            guardian_dob: getValue(localData.guardian_dob, data.guardian_dob),

            is_pep: getValue(localData.is_pep, data.is_pep),
          };


          return finalData;

        });




        if (data.kyc?.length === 0 || data.kyc[0]?.status === COMPLIANCE_REJECTED) {

          setRejectedFlag(false)
        }
        if (statusFlag === COMPLIANCE_NEW) {

          setRejectedFlag(false)
        }
      })

      .catch((err) => {
        getLoadingAlert(HIDING)
        console.error("Error fetching investor master user:", err.response || err.message);
      });

    axios
      .post(base_url + "documents-type/get_document_types")
      .then((res) => {
        getLoadingAlert(HIDING)

        let doctypes = res.data.data;
        let x = [];
        if (Cookies.get("investor_type") === INVESTOR_TYPE_INDIVIDUAL) {

          doctypes.INVESTOR_INDIVIDUAL_KYC_FORM_DOCS.forEach((element) => {
            x.push({ doc_type: element, is_upload: false, file_name: "" });
          });
        }
        if (Cookies.get("investor_type") === INVESTOR_TYPE_COMPANY) {

          doctypes.INVESTOR_COMPANY_KYC_FORM_DOCS.forEach((element) => {
            x.push({ doc_type: element, is_upload: false, file_name: "" });
          });
        }
        setDownload(x);
      })
      .catch((err) => {
        getLoadingAlert(HIDING)

        console.log(err);
      });

  }, [Cookies.get("user_id"), statusFlag]);


  const [mergedDownloads, setMergedDownloads] = useState([])
  const [savedDocuments, setSavedDocuments] = useState([]);
  useEffect(() => {
    if (statusFlag === COMPLIANCE_NEW) {
      const currentDocuments = getDocuments?.kyc_documents || [];
      setSavedDocuments((prevDocuments) => Array.isArray(prevDocuments)
        ? [...prevDocuments, ...currentDocuments]
        : currentDocuments);
      const updatedDownloads = download?.map((item) => {
        const matchedDocument = getDocuments?.kyc_documents?.find((doc) => {
          const trimmedDocType = doc.document_type?.replace(/\s+/g, '').trim();
          const trimmedItemType = item.doc_type?.replace(/\s+/g, '').trim();
          return trimmedItemType.includes(trimmedDocType);
        });

        return matchedDocument
          ? { ...item, ...matchedDocument, is_upload: true }
          : item;
      });
      setMergedDownloads(updatedDownloads);

    }
    else {
      setMergedDownloads(download);
    }
  }, [statusFlag, getDocuments]);
  useEffect(() => {
    if (preOthers.length !== 0) {
      setMergedDownloads(prevDownloads =>
        Array.isArray(prevDownloads)
          ? prevDownloads.map(item =>
            item.doc_type === 'Others' ? { ...item, is_upload: true } : item
          ) : prevDownloads
      );
    }
  }, [preOthers])


  const [isDataNull, setIsDataNull] = useState(false);
  const [index, setIndex] = useState(0)
  const [shareHolderData, setShareHolderData] = useState([
    { index: index, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" },
  ]);
  const [rejectedShareHolderData, setRejectedShareHolderData] = useState([
    { index: index, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" },
  ]);


  const handleInputChange = (index, columnName, value) => {
    if ((investorDatauser?.kyc?.length === 0) ||
      (investorDatauser?.kyc?.length > 0 && statusFlag === COMPLIANCE_NEW)) {
      const newData = [...shareHolderData];
      newData[index][columnName] = value;
      setShareHolderData(newData);
    }

    if (statusFlag === COMPLIANCE_REJECTED) {

      const newData = [...rejectedShareHolderData];
      newData[index][columnName] = value;
      setRejectedShareHolderData(newData);
    }



  };

  let plusDisabled = shareHolderData.some((obj) => Object.values(obj).some((value) => value === ''))
  const handleAddRow = () => {

    if (!plusDisabled) {
      const newRow = { index: index + 1, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" };
      if (investorDatauser?.kyc?.length === 0 || statusFlag === COMPLIANCE_NEW) { setShareHolderData([...shareHolderData, newRow]); }
      if (statusFlag === COMPLIANCE_REJECTED) { setRejectedShareHolderData([...rejectedShareHolderData, newRow]); }

      setIndex(index + 1)
    }
  };
  const handleRemoveRow = (index) => {
    if (index !== 0) {
      if (investorDatauser?.kyc?.length === 0 || statusFlag === COMPLIANCE_NEW) { setShareHolderData(shareHolderData.filter((_, i) => i !== index)); }
      if (statusFlag === COMPLIANCE_REJECTED) { setShareHolderData(shareHolderData.filter((_, i) => i !== index)); }
    }
  };





  const handleFieldChange = (fieldName, value) => {

    if (Cookies.get("investor_type") === INVESTOR_TYPE_INDIVIDUAL) {

      let updatedData;

      if (fieldName === "country") {
        updatedData = {
          ...indivInvFormData,
          country: value,
          country_of_birth: value,
        };

        setIndivInvFormData(updatedData);
        localStorage.setItem(`indivInvData_${investorDatauser?.user_id}`, JSON.stringify(updatedData)); // ✅ save

        return;
      }

      if (fieldName === "gender" ) {
        updatedData = {
          ...indivInvFormData,
          [fieldName]: value
        };
      } else {
        updatedData = {
          ...indivInvFormData,
          [fieldName]: value
        };
      }

      // update state
      setIndivInvFormData(updatedData);

      // save to localStorage
      localStorage.setItem(`indivInvData_${investorDatauser?.user_id}`, JSON.stringify(updatedData));

      // existing logic
      setCompanyFormData((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));

      if (statusFlag === COMPLIANCE_REJECTED) {
        setCompanyFormData((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }));
        setRejectedInvDetails((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }));
      }

      if (investorDatauser?.kyc[0]?.status === COMPLIANCE_REJECTED) {
        setSaveKYCBtn(false)
        setRejectedInvDetails((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }))
      }
    }

    // validations
    setValidateErrors(prevData => ({ ...prevData, [fieldName]: false }));
    setValidatePersonalErrors(prevData => ({ ...prevData, [fieldName]: false }));
    removeCompletedStep(currentStep);
    setValidateIdErrors(prevData => ({ ...prevData, [fieldName]: false }));


    // COMPANY FLOW (optional save)
    if (Cookies.get("investor_type") === INVESTOR_TYPE_COMPANY) {

      if (investorDatauser?.kyc?.length === 0 || statusFlag === COMPLIANCE_NEW) {
        setCompanyFormData((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }))
      }
      if (statusFlag === COMPLIANCE_REJECTED) {
        setCompanyFormData((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }));
        setRejectedInvDetails((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }));
      }
      else if (investorDatauser?.kyc[0]?.status === COMPLIANCE_REJECTED) {
        setSaveKYCBtn(false)
        setRejectedInvDetails((prevData) => ({
          ...prevData,
          [fieldName]: value,
        }));
      }
    }

  };

  var currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);

  const tomorrow = currentDate.toISOString().split('T')[0];


  let rowCount = window.screen.availWidth > 1860 ? 8 : 4;

  const handleCustomerChange = (index, value) => {
    if ((investorDatauser?.kyc?.length === 0) ||
      (investorDatauser?.kyc?.length > 0 && statusFlag === COMPLIANCE_NEW)) {
      const customers = [...updatedCustomers];
      customers[index] = value;
      setUpdatedCustomers(customers)
    }

    if (statusFlag === COMPLIANCE_REJECTED) {
      let customers = [...rejectedCustomers];
      customers[index] = value;
      setRejectedCustomers(customers)
      setUpdatedCustomers(customers)
    }

  };

  const handleSupplierChange = (index, value) => {

    if ((investorDatauser?.kyc?.length === 0) ||
      (investorDatauser?.kyc?.length > 0 && statusFlag === COMPLIANCE_NEW)) {
      const suppliers = [...updatedSuppliers];
      suppliers[index] = value;
      setUpdatedSuppliers(suppliers)
    }
    if (statusFlag === COMPLIANCE_REJECTED) {
      const suppliers = [...rejectedSuppliers];
      suppliers[index] = value;
      setRejectedSuppliers(suppliers)
      setUpdatedSuppliers(suppliers)
    }

  };

  const handleBankChange = (index, value) => {
    if (investorDatauser?.kyc?.length === 0) {
      const banks = [...updatedBanks];
      banks[index] = value;
      setUpdatedBanks(banks)
    }

    if (statusFlag === COMPLIANCE_REJECTED) {
      const banks = [...rejectedBanks];
      banks[index] = value;
      setRejectedBanks(banks)
      setUpdatedBanks(banks)
    }
  };


  const handleChange = (event, item, index) => {
    const maxFileSize = 5242880;
    const files = Array.from(event.target.files);
    let sample_download = [];
    if (isDataNull) sample_download = [...download];
    else sample_download = [...mergedDownloads];
    sample_download.forEach((doc) => {
      if (doc.doc_type === item.doc_type) {
        if (item.doc_type === "Others") {
          if (others.length < 10) {
            const validFiles = files.filter((file) => file.size < maxFileSize);
            const invalidFiles = files.filter((file) => file.size >= maxFileSize);
            if (invalidFiles.length > 0) {
              toast.error("Some files exceed 5MB and were not uploaded.", {
                toastId: 7,
              });
            }
            doc.is_upload = true;
            doc.uploaded_files = [...(doc.uploaded_files || []), ...validFiles.map((file) => ({
              file_name: file.name,
              document_url: file,
            }))];
            validFiles.forEach((file) => {
              setOthers((prevItems) => [...prevItems, file]);
            });
          } else {
            toast.warn("Max limit of 50 files reached!");
          }
        } else {
          if (files[0]?.size < maxFileSize) {
            doc.is_upload = true;
            doc.document_type = item.doc_type;
            doc.document_url = files[0];
            doc.file_name = files[0].name;
          } else {
            toast.error("File size should be less than 5MB", {
              toastId: 7,
            });
          }
        }
      }
    });

    setDownload(sample_download);
  };




  const investorKycId = investorDatauser?.kyc?.[0]?.investor_kyc_id || null;
  const saveTimerRef = useRef(null);

  const getFormData = () => ({
    investor_kyc_id: investorDatauser.kyc[0]?.investor_kyc_id,
    user_id: investorDatauser.user_id,
    investor_id: investorDatauser.investor_id,
    fullName: indivInvFormData.investor_name,
    country: indivInvFormData.country,
    idType: indivInvFormData.idType1,
    idType2: indivInvFormData.idType2,

  });

  useEffect(() => {
    if (!investorKycId) return;

    saveTimerRef.current = setTimeout(async () => {
      await saveDraft({
        investorKycId,
        currentStep,
        formData: getFormData(),
        uploadedFiles,
        livenessSessionId,
      });
    }, 2000);

    return () => clearTimeout(saveTimerRef.current);
  }, []);





  const uploadFile = async ({
    file,
    investorKycId,
    documentType,
    investorId,
    userId,
  }) => {
    const form = new FormData();
    form.append("file", file);
    form.append("investor_kyc_id", investorKycId);
    form.append("document_type", documentType);
    if (investorId) form.append("investor_id", investorId);
    if (userId) form.append("user_id", userId);

    const base = EKYC_BASE_URL;
    const res = await fetch(`${base}/ekyc/upload`, {
      method: "POST",
      body: form,
    });
    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`Upload failed: ${txt}`);
    }

    const js = await res.json();
    return js?.data || js;
  };

  /**
 * Save draft submission (auto-save).
 * Stores form data + blob URLs for resume capability.
 */
  const saveDraft = async ({
    investorKycId,
    currentStep,
    formData,
    uploadedFiles,
    livenessSessionId,
  }) => {
    const body = {
      investor_kyc_id: investorKycId,
      current_step: currentStep,
      form_data: formData,
      uploaded_files: uploadedFiles,
      liveness_session_id: livenessSessionId,
    };

    const base = EKYC_BASE_URL;

    const res = await fetch(`${base}/ekyc/draft`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // ✅ REQUIRED
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`Draft save failed: ${txt}`);
    }

    const js = await res.json();
    return js?.data || js;
  };


  /**
   * Get saved draft for resume capability.
   */
  const getDraft = async (investorKycId) => {
    if (!investorKycId) return null;

    const base = EKYC_BASE_URL;

    const res = await fetch(`${base}/ekyc/draft/${investorKycId}`, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    });
    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`Get draft failed: ${txt}`);
    }

    const js = await res.json();
    return js?.data || js;
  };




  const handleBankStatementChange = async (e, type) => {

    const input = e.target;          // 
    const file = input.files?.[0];

    // handle cancel / no file
    if (!file) {
      return; // user cancelled file selection
    }

    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.type !== "application/pdf") {
      toast.error("Only PDF files are allowed");
      return;
    }
    if (file.size > maxSize) {
      toast.error("File size should not exceed 10MB");
      return;
    }

    try {
      getLoadingAlert(LOADING);

      const res = await uploadFile({
        file,
        investorKycId: investorDatauser?.kyc?.[0]?.investor_kyc_id,
        investorId: investorDatauser?.investor_id,
        userId: investorDatauser?.user_id,
        documentType: type === "bank" ? "bank_statement" : "address_proof",
      });

      /* -------------------------------
          Update indivInvFormData
      -------------------------------- */
      setIndivInvFormData((prev) => ({
        ...prev,
        ...(type === "bank"
          ? {
            bank_statement_blob_url: res.blob_url,
            bank_statement_file_name: res.original_file_name,
          }
          : {
            address_proof_blob_url: res.blob_url,
            address_proof_file_name: res.original_file_name,
          }),
      }));

      /* -------------------------------
          Update uploadedFiles (draft)
      -------------------------------- */
      const nextUploadedFiles = {
        ...uploadedFiles,
        [type === "bank" ? "bank_statement" : "address_proof"]: {
          blob_url: res.blob_url,
          original_file_name: res.original_file_name,

        },
      };

      setUploadedFiles(nextUploadedFiles);

      /* -------------------------------
          Save draft immediately
      -------------------------------- */
      await saveDraft({
        investorKycId: investorDatauser?.kyc?.[0]?.investor_kyc_id,
        currentStep,
        formData: getFormData(),
        uploadedFiles: nextUploadedFiles,
        livenessSessionId,
      });

      if (type === "bank") {
        setBankStatementError(false);
      }

      toast.success("File uploaded & draft saved");
    } catch (err) {
      console.error(err);
      toast.error("File upload failed");
    } finally {
      getLoadingAlert(HIDING);
      e.target.value = ""; // allow re-upload same file
    }
  };




  const handleSelfieAndLivenessChange = async ({
    selfieFile,
    livenessVideo,
    livenessSessionId,
  }) => {
    if (!selfieFile || !livenessVideo || !investorKycId) return;
    try {
      getLoadingAlert(LOADING);

      /* -------------------------------
          Upload selfie
      -------------------------------- */
      const selfieRes = await uploadFile({
        file: selfieFile,
        investorKycId: investorDatauser?.kyc?.[0]?.investor_kyc_id,
        investorId: investorDatauser?.investor_id,
        userId: investorDatauser?.user_id,
        documentType: "selfie",
      });

      /* -------------------------------
          Upload liveness video
      -------------------------------- */
      const livenessRes = await uploadFile({
        file: livenessVideo,
        investorKycId: investorDatauser?.kyc?.[0]?.investor_kyc_id,
        investorId: investorDatauser?.investor_id,
        userId: investorDatauser?.user_id,
        documentType: "liveness_video",
      });

      /* -------------------------------
          Update UI form state
      -------------------------------- */
      setIndivInvFormData((prev) => ({
        ...prev,
        selfie_blob_name: selfieRes.original_file_name,
        selfie_blob_url: selfieRes.blob_url,
        liveness_video_blob_name: livenessRes.original_file_name,
        liveness_video_blob_url: livenessRes.blob_url,
        livenessSessionId: livenessSessionId || null,
      }));

      /* -------------------------------
          Update draft uploadedFiles
      -------------------------------- */
      const nextUploadedFiles = {
        ...uploadedFiles,
        selfie: {
          blob_url: selfieRes.blob_url,
          original_file_name: selfieRes.original_file_name,

        },
        liveness_video: {
          blob_url: livenessRes.blob_url,
          original_file_name: livenessRes.original_file_name,

        },
      };

      setUploadedFiles(nextUploadedFiles);
      setLivenessSessionId(livenessSessionId)

      /* -------------------------------
          Persist draft immediately
      -------------------------------- */
      await saveDraft({
        investorKycId,
        currentStep,
        formData: getFormData(),
        uploadedFiles: nextUploadedFiles,
        livenessSessionId: livenessSessionId || null,
      });

      /* -------------------------------
          UI success handling
      -------------------------------- */
      setIsSelfieDone(true);
      setShowSelfieModal(false);
      toast.success("Selfie & liveness uploaded and draft saved");
    } catch (err) {
      console.error(err);
      setIsSelfieDone(false);
      toast.error("Selfie / liveness upload failed");
    } finally {
      getLoadingAlert(HIDING);
    }
  };




  const handleIdentityChange = async (e, field) => {
    const file = e.target.files?.[0];
    if (!file || !investorKycId) return;

    const maxSize = 5 * 1024 * 1024; // 5MB

    //  Validation
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed");
      e.target.value = null;
      return;
    }

    if (file.size > maxSize) {
      toast.error("File size should be less than 5MB");
      e.target.value = null;
      return;
    }

    try {
      getLoadingAlert(LOADING);

      const ID_DOCUMENT_TYPE_MAP = {
        id1Front: "id_front",
        id1Back: "id_back",
        id2Front: "id_front2",
        id2Back: "id_back2",
      };

      const documentType = ID_DOCUMENT_TYPE_MAP[field];

      const res = await uploadFile({
        file,
        investorKycId,
        investorId: investorDatauser?.investor_id,
        userId: investorDatauser?.user_id,
        documentType,
      });




      /* --------------------------------
         Update UI form state
     --------------------------------- */
      setIndivInvFormData((prev) => ({
        ...prev,
        [`${field}BlobUrl`]: res.blob_url,
        [`${field}Name`]: res.original_file_name, // for UI display
      }));




      /* --------------------------------
         Update draft uploadedFiles
     --------------------------------- */
      const nextUploadedFiles = {
        ...uploadedFiles,
        [documentType]: {
          blob_url: res.blob_url,
          original_file_name: res.original_file_name,

        },
      };


      setUploadedFiles(nextUploadedFiles);

      /* --------------------------------
                Persist draft immediately
            --------------------------------- */
      await saveDraft({
        investorKycId,
        currentStep,
        formData: getFormData(),
        uploadedFiles: nextUploadedFiles,
        livenessSessionId,
      });


      /* --------------------------------
        Clear error state
    --------------------------------- */
      setIdentityError((prev) => ({
        ...prev,
        [field]: false,
      }));


      toast.success("File uploaded & draft saved");
    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
    } finally {
      getLoadingAlert(HIDING);
      e.target.value = ""; // allow re-upload same file
    }
  };


  const handleChangeDownload = (event, item) => {
    if (item.document_url && typeof item.document_url === 'string') {
      window.open(item.document_url, '_blank');
    } if (item.document_url instanceof File) {
      const fileURL = URL.createObjectURL(item.document_url);
      window.open(fileURL, '_blank');
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [masterInvestorData, setMasterInvestorData] = useState([])
  useEffect(() => {
    if (masterInvestorData?.top_5_customers?.length > 0) {
      setUpdatedCustomers(masterInvestorData.top_5_customers);
    }
    if (masterInvestorData?.top_5_suppliers?.length > 0) {
      setUpdatedSuppliers(masterInvestorData.top_5_suppliers);
    }
    if (masterInvestorData?.banks_list?.length > 0) {
      setUpdatedBanks(masterInvestorData.banks_list);
    }
    if (masterInvestorData?.shareholders?.length > 0) {
      setShareHolderData(masterInvestorData.shareholders);
    }
  }, [masterInvestorData]);





  console.log('indivInvFormData', indivInvFormData)




  useEffect(() => {
    if (investorDatauser?.length > 0) {
      if (investorDatauser?.kyc[0]?.status === COMPLIANCE_APPROVED) {
        Cookies.set("kyc_status", COMPLIANCE_APPROVED, { expires: 7 })
      }
    }

    getLoadingAlert(LOADING);

    if (investorDatauser?.user_id) {
      axios.post(
        base_url + "investor-master/get_investor_kyc_user",
        { user_id: investorDatauser.user_id }
      ).then(res => {
        getLoadingAlert(HIDING)

        const kycData = res.data.data[0];
        const documents = res.data.data[1]?.kyc_documents || [];
        const investorData = res.data.data[2]?.investorData;
        const ekycChecks = res.data.data[3]?.ekyc_checks;

        if (!kycData) {
          setIsDataNull(true);
          setStatusFlag(COMPLIANCE_NEW);

          return;
        }

        if (
          kycData.kyc_expiry_date &&
          kycData.kyc_expiry_date <= Date.now()
        ) {


          // setStatusFlag(COMPLIANCE_NEW);
          setStatusFlag(kycData.status);
        } else {

          setStatusFlag(kycData.status);
        }



        setMasterInvestorData({
          kycData,
          investorData,
          documents,
          ekycChecks
        });

        setGetDocuments(documents);
        setSavedDocuments(documents);

        setRejectedCustomers(kycData?.top_5_customers)
        setRejectedSuppliers(kycData?.top_5_suppliers)
        setRejectedBanks(kycData?.banks_list)
        setRejectedShareHolderData(kycData?.shareholders)
        if (kycData && Cookies.get("investor_type") === INVESTOR_TYPE_INDIVIDUAL) {
          setRejectedInvDetails({
            "investor_id": kycData.investor_id,
            "type": kycData.type,
            "investor_kyc_id": kycData.investor_kyc_id,
            "user_id": kycData.user_id,
            "gender": kycData.gender,
            "phone": kycData.phone,
            "registered_address": kycData.registered_address,
            "nationality": kycData.nationality,
            "country": kycData.country,
            "home_country_contact": kycData.home_country_contact,
            "country_of_birth": kycData.country_of_birth,
            "date_of_birth": kycData.date_of_birth,
            "passport_number": kycData.passport_number,
            "passport_expiry_date": kycData.passport_expiry_date,
            "description_of_income": kycData.description_of_income,
            "sourse_of_fund": kycData.sourse_of_fund,
            "nominee_details": kycData.nominee_details,
            "nominee_name": "",
            "nominee_dob": "",
            "nominee_contact": "",
            "nominee_address": "",
            "nominee_relationship": "",
            "guardian_name": "",
            "guardian_dob": "",
            "guardian_address": "",
            "gender":kycData.gender,
            "investor_company_name":kycData.investor_company_name,
            "name_of_employer": kycData.name_of_employer,
            "country_of_employer": kycData.country_of_employer,
            "national_id": kycData.national_id,
            "other_passport_details": kycData.other_passport_details,
            "committed_principal": kycData.committed_principal,
            "is_pep": kycData.is_pep,
          })
        }
        else {
          setRejectedInvDetails({
            "investor_id": kycData?.investor_id,
            "investor_kyc_id": kycData?.investor_kyc_id,
            "user_id": kycData?.user_id,
            "phone": kycData?.phone,
            "registered_address": kycData?.registered_address,
            "sector": kycData?.sector,
            "type": kycData?.type,
            "investor_company_type": kycData?.investor_company_type,
            "investor_company_name": kycData?.investor_company_name,
            "country": kycData?.country,
            "trade_license_no": kycData?.trade_license_no,
            "trade_license_expiry_date": kycData?.trade_license_expiry_date,
            "place_of_incorporation": kycData?.place_of_incorporation,
            "date_of_incorporation": kycData?.date_of_incorporation,
            "description_of_business": kycData?.description_of_business,
            "beneficial_owner_with_percentage_holding": kycData?.beneficial_owner_with_percentage_holding,
            "shareholders": kycData?.shareholders,
            "products_by_the_company": kycData?.products_by_the_company,
            "origin_of_products": kycData?.origin_of_products,
            "import_countries_with_percentage": kycData?.import_countries_with_percentage,
            "export_countries_with_percentage": kycData?.export_countries_with_percentage,
            "re_export_countries_with_percentage": kycData?.re_export_countries_with_percentage,
            "top_5_customers": kycData?.top_5_customers,
            "top_5_suppliers": kycData?.top_5_suppliers,
            "committed_principal": kycData?.committed_principal,
            "no_of_full_time_employees": kycData?.no_of_full_time_employees,
            "is_pep": kycData?.is_pep

          })
        }
      });
    }

  }, [investorDatauser?.user_id, investorDatauser])

  const [saveKYCBtn, setSaveKYCBtn] = useState(false)

  const handleSaveDraft = async () => {
    setSaveKYCBtn(true);
    const fInvData = new FormData();


    const data = {
      "investor_id": investorDatauser.investor_id,
      "user_id": investorDatauser.user_id,
      "gender": "",
      "phone": investorDatauser.phone,
      "registered_address": "",
      "nationality": investorDatauser.nationality,
      "country": investorDatauser.country,
      "home_country_contact": "",
      "country_of_birth": "",
      "date_of_birth": investorDatauser.country_of_birth,
      "passport_number": "",
      "passport_expiry_date": "",
      "description_of_income": "",
      "sourse_of_fund": "",
      "nominee_details": "",
      "nominee_name": "",
      "nominee_dob": "",
      "nominee_contact": "",
      "nominee_address": "",
      "nominee_relationship": "",
      "guardian_name": "",
      "guardian_dob": "",
      "guardian_address": "",
      "name_of_employer": "",
      "country_of_employer": "",
      "national_id": "",
      "other_passport_details": "",
      "committed_principal": "",
      "created_by": investorDatauser.created_by,
      "is_pep": ""
    };


    for (const key in data) {
      if (key === "date_of_birth" || key === "passport_expiry_date") {
        if (data.hasOwnProperty(key) && indivInvFormData[key] != undefined) {
          const timstampDate = new Date(indivInvFormData[key]).getTime()
          fInvData.append(key, timstampDate);
        }
      } else if (data.hasOwnProperty(key)) {
        if (indivInvFormData[key] !== undefined && indivInvFormData[key] !== null) {
          fInvData.append(key, indivInvFormData[key]);
        }
        else if (data[key] !== undefined && data[key] != null) {
          fInvData.append(key, data[key]);
        }
        else {
          fInvData.append(key, "");
        }
      }
    }

    let documents_lst = [];

    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          is_upload: !!eachDoc.document_url
        });
      }
    });
    documents_lst.forEach(elem => {
      if (elem.document_url.name) {
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fInvData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
      }
    })

    if (others.length !== 0) {
      others.filter((doc) => doc && doc.name).forEach((doc) => {
        const fileName = doc?.name;
        if (fileName) {
          fInvData.append('file_name', fileName);
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fInvData.append('file', doc, "Others" + "." + fileExtension);
        }
      });
    }
    if (!isDataNull) {
      fInvData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
    }
    fInvData.append('save_as_draft', '1');
    fInvData.append('status', statusFlag);
    fInvData.append("deleted_doc", deletedDoc);


    try {
      const response = await axios.post(base_url + "investor-master/save_investor_master", fInvData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.data.message === 'Investor KYC draft saved successfully') {
        toast.success("Draft saved successfully", {
          toastId: 40,
        });
      }
    } catch (error) {
      toast.error("Failed to save draft", {
        toastId: 41,
      });
    }
    finally {
      setSaveKYCBtn(false);
      setTimeout(() => {
        window.location.reload();
      }, 200)
    }
  }


  const getExtensionFromURL = (url) => {
    try {
      const pathname = new URL(url).pathname;
      const parts = pathname.split('.');
      return parts.length > 1 ? parts.pop() : null;
    } catch (error) {
      return null;
    }
  };
  const [documents, setDocuments] = useState([]);
  const handleSaveDraftCompany = async () => {
    setSaveKYCBtn(true);
    const fData = new FormData();
    const data = {
      "investor_id": investorDatauser.investor_id,
      "user_id": investorDatauser.user_id,
      "phone": investorDatauser.phone,
      "beneficial_owner_with_percentage_holding": "",

      "committed_principal": "",

      "date_of_incorporation": "",

      "description_of_business": "",

      "export_countries_with_percentage": "",

      "import_countries_with_percentage": "",

      "investor_company_type": investorDatauser.type,
      "is_pep": "",

      "no_of_full_time_employees": "",

      "origin_of_products": "",

      "place_of_incorporation": "",

      "products_by_the_company": "",

      "re_export_countries_with_percentage": "",

      "registered_address": "",

      "sector": "",

      "trade_license_expiry_date": "",

      "trade_license_no": "",

      "created_by": investorDatauser.created_by,
      "country": investorDatauser.country,
    };
    for (const key in data) {
      if (key === "date_of_incorporation" || key === "trade_license_expiry_date") {
        if (data.hasOwnProperty(key) && companyFormData[key] != undefined) {
          const timstampDate = new Date(companyFormData[key]).getTime()
          fData.append(key, timstampDate);
        }
      }
      else if (data.hasOwnProperty(key)) {
        if (companyFormData[key] !== undefined && companyFormData[key] !== null) {
          fData.append(key, companyFormData[key]);
        }
        else if (data[key] !== undefined && data[key] != null) {
          fData.append(key, data[key]);
        }
        else {
          fData.append(key, "");
        }
      }
    }
    for (let i = 0; i < updatedCustomers.length; i++) {
      if (updatedCustomers[i]) {
        fData.append('top_5_customers', updatedCustomers[i]);
      }
    }

    for (let i = 0; i < updatedSuppliers.length; i++) {
      if (updatedSuppliers[i]) {
        fData.append('top_5_suppliers', updatedSuppliers[i]);
      }
    }

    for (let i = 0; i < updatedBanks.length; i++) {
      if (updatedBanks[i]) {
        fData.append('banks_list', updatedBanks[i]);
      }
    }
    let documents_lst = [];
    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          is_upload: !!eachDoc.document_url
        });
      }
    });

    documents_lst.forEach(elem => {
      if (elem.document_url.name) {
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);

      }
    })

    if (others.length !== 0) {
      others.filter((doc) => doc && doc.name).forEach((doc) => {
        const fileName = doc?.name;
        if (fileName) {
          fData.append('file_name', fileName);
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fData.append('file', doc, "Others" + "." + fileExtension);
        }
      });
    }
    if (!isDataNull) {
      fData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
    }

    if (Array.isArray(getDocuments?.kyc_documents) && getDocuments.kyc_documents.length > 0) {
      getDocuments.kyc_documents.forEach((doc, index) => {
        if (doc?.document_url) {
          documents.push(doc.document_url);
        }
      });
    }
    fData.append('shareholders', JSON.stringify(shareHolderData));
    fData.append("deleted_doc", deletedDoc);
    fData.append('save_as_draft', '1');
    fData.append('status', statusFlag);

    try {
      const response = await axios.post(
        base_url + "investor-master/save_investor_master",
        fData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (response.data.message === 'Investor KYC draft saved successfully') {
        toast.success("Draft saved successfully", {
          toastId: 40,
        });
      }
    }
    catch (error) {
      toast.error("Failed to save draft", {
        toastId: 41,
      });
    }
    finally {
      setSaveKYCBtn(false);
      setTimeout(() => {
        window.location.reload();
      }, 200)
    }
  }


  const handleSavechanges = async (data) => {
    setSaveKYCBtn(true)
    if (Cookies.get("investor_type") === INVESTOR_TYPE_INDIVIDUAL) {


      const fInvData = new FormData();
      const data = {
        "user_id": investorDatauser.user_id,
        "gender": "",
        "investor_company_name": "",
        "phone": investorDatauser.phone,
        "registered_address": "",
        "nationality": investorDatauser.nationality,
        "country": investorDatauser.country,
        "home_country_contact": "",
        "country_of_birth": "",
        "date_of_birth": investorDatauser.country_of_birth,
        "passport_number": "",
        "passport_expiry_date": "",
        "description_of_income": "",
        "sourse_of_fund": "",
        "nominee_details": "",
        "investor_name": "",
        "nominee_name": "",
        "nominee_dob": "",
        "nominee_contact": "",
        "nominee_address": "",
        "nominee_relationship": "",
        "guardian_name": "",
        "guardian_dob": "",
        "guardian_address": "",
        "name_of_employer": "",
        "country_of_employer": "",
        "national_id": "",
        "other_passport_details": "",
        "committed_principal": "",
        "created_by": investorDatauser.created_by,
        "is_pep": "",
        "investor_name": "",
      };


      for (const key in data) {
        if (key === "date_of_birth" || key === "passport_expiry_date") {
          if (data.hasOwnProperty(key) && indivInvFormData[key]) {
            const timstampDate = new Date(indivInvFormData[key]).getTime()
            fInvData.append(key, timstampDate);
          }
        } else if (data.hasOwnProperty(key)) {
          if (indivInvFormData[key] !== undefined) {
            fInvData.append(key, indivInvFormData[key]);
          }
          else if (data[key] !== undefined) {
            fInvData.append(key, data[key]);
          }
        }
      }
      let documents_lst = [];

      if (isDataNull)
        download.map((eachDoc) => {
          if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
            documents_lst.push({
              document_type: eachDoc.document_type,
              document_url: eachDoc.document_url,
              is_upload: !!eachDoc.document_url
            });
          }
        });

      else
        mergedDownloads.map((eachDoc) => {
          if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
            documents_lst.push({
              document_type: eachDoc.document_type,
              document_url: eachDoc.document_url,
              is_upload: !!eachDoc.document_url
            });
          }
        });

      const requiredDocuments = [
        "ID Proof - Address Proof",
        "ID Proof - National ID",
        "ID Proof - Passport/ Government Issued ID",
        "3 Months Bank Account Statement",
        "ID Proof - Nominee",
        "ID Proof - Guardian",
        "Photograph"
      ];


      const allRequiredUploaded = requiredDocuments.every((type) => {
        const normalizedType = type.replace(/[^a-zA-Z0-9]/g, '');
        const isUploaded = documents_lst.some((doc) => {
          const normalizedDocType = doc.document_type.replace(/[^a-zA-Z0-9]/g, '');
          const match = normalizedType.includes(normalizedDocType) && doc.is_upload;
          return match;
        });
        return isUploaded;
      });

      // Check if "Months Bank Account Statement" exists and is uploaded
      const bankStatementUploaded = documents_lst.some(
        (doc) => doc.document_type.includes("Bank Account Statement") && doc.is_upload
      );
      // Set mandatoryDocuments to true if both conditions are met
      const mandatoryDocuments = allRequiredUploaded && bankStatementUploaded;
      if (
        (indivInvFormData?.committed_principal === '' || indivInvFormData?.committed_principal === null) ||
        (indivInvFormData?.country === '' || indivInvFormData?.country === null) ||
        (indivInvFormData?.country_of_birth === '' || indivInvFormData?.country_of_birth === null) ||
        (indivInvFormData?.country_of_employer === '' || indivInvFormData?.country_of_employer === null) ||
        (indivInvFormData?.date_of_birth === '' || indivInvFormData?.date_of_birth === null) ||
        (indivInvFormData?.description_of_income === '' || indivInvFormData?.description_of_income === null) ||
        (indivInvFormData?.nationality === '' || indivInvFormData?.nationality === null) ||
        (indivInvFormData?.gender === '' || indivInvFormData?.gender === null) ||
        (indivInvFormData?.is_pep === '' || indivInvFormData?.is_pep === null) ||
        (indivInvFormData?.name_of_employer === '' || indivInvFormData?.name_of_employer === null) ||
        (indivInvFormData?.national_id === '' || indivInvFormData?.national_id === null) ||
        (indivInvFormData?.nominee_details === '' || indivInvFormData?.nominee_details === null) ||
        (indivInvFormData?.passport_expiry_date === '' || indivInvFormData?.passport_expiry_date === null) ||
        (indivInvFormData?.passport_number === '' || indivInvFormData?.passport_number === null) ||
        (indivInvFormData?.registered_address === '' || indivInvFormData?.registered_address === null) ||
        (indivInvFormData?.sourse_of_fund === '' || indivInvFormData?.sourse_of_fund === null) ||
        (indivInvFormData?.phone === '' || indivInvFormData?.phone === null)



      ) {
        toast.error("Please fill out mandatory fields", {
          toastId: 3,
        });
        setSaveKYCBtn(false)
      }
      else if (!mandatoryDocuments) {
        toast.error("Please upload mandatory documents", {
          toastId: 333,
        });
        setSaveKYCBtn(false)
      }
      else {
        setSaveKYCBtn(true)
        documents_lst.forEach(elem => {
          if (elem.document_url.name) {
            const fileName = elem.document_url.name;
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);
            fInvData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
            if (elem.document_type === "Others") {
              fInvData.append('file_name', fileName);
            }
          }
        })
        fInvData.append("deleted_doc", deletedDoc);
        fInvData.append('save_as_draft', '0');
        fInvData.append('investor_id', investorDatauser.investor_id)
        if (!isDataNull) {
          fInvData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
        }
        if (others.length !== 0) {
          others.filter((doc) => doc && doc.name).forEach((doc) => {
            const fileName = doc?.name;
            if (fileName) {
              fInvData.append('file_name', fileName);
              const lastDotIndex = fileName.lastIndexOf('.');
              const fileExtension = fileName.substring(lastDotIndex + 1);

              fInvData.append('file', doc, "Others" + "." + fileExtension);
            }
          });


        }

        const response = await axios.post(base_url + "investor-master/update_investor_master", fInvData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.message === 'Updated Investor KYC') {
          toast.success("Submitted Successfully", {
            toastId: 42,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      }


    }
    else if (Cookies.get("investor_type") === INVESTOR_TYPE_COMPANY) {

      setSaveKYCBtn(true)
      const fData = new FormData();
      let documents_lst = [];

      if (isDataNull)
        download.map((eachDoc) => {
          if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
            documents_lst.push({
              document_type: eachDoc.document_type,
              document_url: eachDoc.document_url,
              is_upload: !!eachDoc.document_url
            });
          }
        });

      else
        mergedDownloads.map((eachDoc) => {
          if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
            documents_lst.push({
              document_type: eachDoc.document_type,
              document_url: eachDoc.document_url,
              is_upload: !!eachDoc.document_url
            });
          }
        });

      const requiredDocuments = [
        "Valid Trade License",
        "MOA Document",
        "Board Resolution Document",
        "ID Proof - Passport/ Government Issued ID",
        "ID Proof - National ID",
        "VAT Certificate",
        "ID Proof - Address Proof",
      ];
      // Check if all required documents are uploaded
      const allRequiredUploaded = requiredDocuments.every((type) => {
        const normalizedType = type.replace(/[^a-zA-Z0-9]/g, '');
        const isUploaded = documents_lst.some((doc) => {
          const normalizedDocType = doc.document_type.replace(/[^a-zA-Z0-9]/g, '');
          const match = normalizedType.includes(normalizedDocType) && doc.is_upload;
          return match;
        });
        return isUploaded;
      });

      // Check if "Months Bank Account Statement" exists and is uploaded
      const bankStatementUploaded = documents_lst.some(
        (doc) => doc.document_type.includes("Bank Account Statement") && doc.is_upload
      );

      // Set mandatoryDocuments to true if both conditions are met
      const mandatoryDocuments = allRequiredUploaded && bankStatementUploaded;


      for (let i = 0; i < updatedCustomers.length; i++) {
        if (updatedCustomers[i] !== undefined) {
          fData.append('top_5_customers', updatedCustomers[i])
        };
      }
      for (let i = 0; i < updatedSuppliers.length; i++) {
        if (updatedSuppliers[i] !== undefined) { fData.append('top_5_suppliers', updatedSuppliers[i]) };
      }
      // for (let i = 0; i < updatedBanks.length; i++) {
      //   if(updatedBanks[i]!==undefined){fData.append('banks_list', updatedBanks[i])}
      // }

      let companydata = {
        "registered_address": "",
        "sector": "",
        "trade_license_no": "",
        "trade_license_expiry_date": "",
        "place_of_incorporation": "",
        "date_of_incorporation": "",
        "description_of_business": "",
        "beneficial_owner_with_percentage_holding": "",
        // "shareholders": "",
        "products_by_the_company": "",
        "origin_of_products": "",
        "import_countries_with_percentage": "",
        "export_countries_with_percentage": "",
        "re_export_countries_with_percentage": "",
        "committed_principal": "",
        "no_of_full_time_employees": "",
        "is_pep": ""
      }


      for (const key in companydata) {
        if (key === "trade_license_expiry_date" || key === "date_of_incorporation") {
          if (companydata.hasOwnProperty(key) && companyFormData[key] != undefined) {
            const timstampDate = new Date(companyFormData[key]).getTime()
            fData.append(key, timstampDate);
          }
        } else if (companydata.hasOwnProperty(key)) {
          if (companydata[key] !== undefined) {
            fData.append(key, companyFormData[key]);
          }
          else if (companydata[key] !== undefined) {
            fData.append(key, companydata[key]);
          }
        }
      }

      fData.append('shareholders', JSON.stringify(shareHolderData));


      if (
        (companyFormData?.sector === '' || companyFormData?.sector === null) ||
        (companyFormData?.country === '' || companyFormData?.country === null) ||
        (companyFormData?.registered_address === '' || companyFormData?.registered_address === null) ||
        (companyFormData?.investor_company_type === '' || companyFormData?.investor_company_type === null) ||
        (companyFormData?.phone === '' || companyFormData?.phone === null) ||
        (companyFormData?.committed_principal === '' || companyFormData?.committed_principal === null) ||
        (companyFormData?.place_of_incorporation === '' || companyFormData?.place_of_incorporation === null) ||
        (companyFormData?.date_of_incorporation === '' || companyFormData?.date_of_incorporation === null) ||
        (companyFormData?.trade_license_no === '' || companyFormData?.trade_license_no === null) ||
        (companyFormData?.trade_license_expiry_date === '' || companyFormData?.trade_license_expiry_date === null) ||
        (companyFormData?.description_of_business === '' || companyFormData?.description_of_business === null) ||
        (companyFormData?.beneficial_owner_with_percentage_holding === '' || companyFormData?.beneficial_owner_with_percentage_holding === null) ||
        (companyFormData?.products_by_the_company === '' || companyFormData?.products_by_the_company === null) ||
        (companyFormData?.origin_of_products === '' || companyFormData?.origin_of_products === null) ||
        (companyFormData?.import_countries_with_percentage === '' || companyFormData?.import_countries_with_percentage === null) ||
        (companyFormData?.export_countries_with_percentage === '' || companyFormData?.export_countries_with_percentage === null) ||
        (companyFormData?.re_export_countries_with_percentage === '' || companyFormData?.re_export_countries_with_percentage === null) ||
        (companyFormData?.no_of_full_time_employees === '' || companyFormData?.no_of_full_time_employees === null) ||
        (companyFormData?.top_5_customers === '' || companyFormData?.top_5_customers === null) ||
        (companyFormData?.top_5_suppliers === '' || companyFormData?.top_5_suppliers === null) ||
        (companyFormData?.is_pep === '' || companyFormData?.is_pep === null)
      ) {
        toast.error("Please fill out mandatory fields", {
          toastId: 3,
        });
        setSaveKYCBtn(false)
      } else if (!mandatoryDocuments) {
        toast.error("Please upload madatory documents", {
          toastId: 526,
        });
      }
      else if (plusDisabled) {
        toast.error("Please fill atleast one shareholder details", {
          toastId: 3,
        });
        setSaveKYCBtn(false)
      }
      else {
        setSaveKYCBtn(true)

        const fetchFile = async (url) => {
          const response = await fetch(url);
          const blob = await response.blob();
          return blob;
        };
        documents_lst.forEach(async (elem) => {
          if (elem.document_url && elem.document_url.name) {
            const fileName = elem.document_url.name;
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);
            fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
          }
          else {
            const url = elem.document_url;
            const fileExtension = url.split('.').pop();

            try {
              const fileBlob = await fetchFile(url);
              fData.append('file', fileBlob, elem.document_type + "." + fileExtension);
            } catch (error) {
              console.error("Error fetching file from URL:", error);
            }
          }
        });
        if (others.length !== 0) {
          others.filter((doc) => doc && doc.name).forEach((doc) => {
            const fileName = doc?.name;
            if (fileName) {
              fData.append('file_name', fileName);
              const lastDotIndex = fileName.lastIndexOf('.');
              const fileExtension = fileName.substring(lastDotIndex + 1);
              fData.append('file', doc, "Others" + "." + fileExtension);
            }
          });
        }
        if (!isDataNull) {
          fData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
        }
        fData.append("investor_id", investorDatauser.investor_id)
        fData.append("user_id", investorDatauser.user_id)
        fData.append("phone", investorDatauser.phone)
        fData.append("type", investorDatauser.type)
        fData.append("country", investorDatauser.country)
        fData.append("investor_company_name", investorDatauser.investor_company_name)


        fData.append("deleted_doc", deletedDoc);
        fData.append('save_as_draft', '0');

        const response = await axios.post(base_url + "investor-master/update_investor_master", fData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });


        if (response.data.message === 'Updated Investor KYC') {
          toast.success("Submitted Successfully", {
            toastId: 42,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      }
    }
  }

  const handleSaveKYCDraft = async () => {
    const fInvData = new FormData();

    fInvData.append("user_id", investorDatauser.user_id);
    fInvData.append("investor_id", investorDatauser.investor_id);
    fInvData.append("step_count", currentStep);

    if (investorDatauser?.kyc?.length) {
      fInvData.append(
        "investor_kyc_id",
        investorDatauser.kyc[0].investor_kyc_id
      );
    }

    if (!investorDatauser?.kyc?.length && investorDatauser?.created_by) {
      fInvData.append("created_by", investorDatauser.created_by);
    }

    const data = [
      "gender",
      "phone",
      "registered_address",
      "nationality",
      "country",
      "home_country_contact",
      "investor_company_name",
      "country_of_residence",
      "passport_number",

      "description_of_income",
      "sourse_of_fund",
      "nominee_details",
      "nominee_name",
      "nominee_contact",
      "nominee_address",
      "nominee_relationship",

      "name_of_employer",
      "country_of_employer",
      "national_id",
      "other_passport_details",
      "committed_principal",
      "is_pep",
      "investor_name",
    ];

    data.forEach((key) => {
      fInvData.append(key, indivInvFormData[key] ?? "");
    });



    const appendDateIfValid = (key, value) => {
      if (!value) return;

      let time = null;

      // already timestamp
      if (typeof value === "number") {
        time = value;
      }
      // Date object
      else if (value instanceof Date) {
        time = value.getTime();
      }
      // string timestamp
      else if (!isNaN(Number(value))) {
        time = Number(value);
      }

      if (time && !isNaN(time)) {
        fInvData.append(key, time);
      }
    };

    fInvData.append("country_of_birth", indivInvFormData.country);

    appendDateIfValid("date_of_birth", indivInvFormData.date_of_birth);
    appendDateIfValid("nominee_dob", indivInvFormData.nominee_dob);


    if (isMinor) {
      fInvData.append("guardian_name", indivInvFormData.guardian_name ?? "");
      fInvData.append("guardian_address", indivInvFormData.guardian_address ?? "");
      appendDateIfValid("guardian_dob", indivInvFormData.guardian_dob);
    } else {
      fInvData.append("guardian_name", "");
      fInvData.append("guardian_address", "");
      fInvData.append("guardian_dob", "");
    }

    appendDateIfValid("passport_expiry_date", indivInvFormData.passport_expiry_date);




    fInvData.append('save_as_draft', '1');
    fInvData.append('status', statusFlag);
    fInvData.append("deleted_doc", deletedDoc);

    getLoadingAlert(LOADING)

    try {
      const response = await axios.post(base_url + "investor-master/update_investor_master", fInvData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      getLoadingAlert(HIDING)
      await fetchInvestorMaster();
      // await loadDraftClick();


      if (response.data.message === 'Investor KYC draft saved successfully') {
        toast.success("Draft saved successfully", {
          toastId: 40,
        });
      }
    } catch (error) {
      getLoadingAlert(HIDING)
      toast.error("Failed to save draft", {
        toastId: 41,
      });
    }

  }


  const handleViewFile = async (documentType) => {
    try {
      const investorKycId = investorDatauser?.kyc?.[0]?.investor_kyc_id || null;
      const base = EKYC_BASE_URL;
      getLoadingAlert(LOADING);
      const response = await axios.get(
        `${base}/ekyc/draft/${investorKycId}/file/${documentType}`,
        {
          responseType: "blob", // 🔑 REQUIRED
          headers: {
            Authorization: `Bearer ${Cookies.get("User_Accesstoken")}`,
          },
        }
      );
      getLoadingAlert(HIDING);

      const contentType =
        response.headers["content-type"] || response.data.type;


      // Create URL from blob
      const fileUrl = URL.createObjectURL(
        new Blob([response.data], { type: contentType })
      );

      // ✅ Open based on type
      if (contentType.includes("pdf")) {
        window.open(fileUrl, "_blank");
      } else if (contentType.startsWith("image/")) {
        window.open(fileUrl, "_blank");
      } else {
        console.warn("Unsupported file type:", contentType);
        window.open(fileUrl, "_blank"); // fallback
      }
    } catch (error) {
      getLoadingAlert(HIDING);

      console.error("View file error:", error);
    }
  };

  const DELETE_DOCUMENT_CONFIG = {
    bank_statement: {
      fileNameKey: "bank_statement_file_name",
      blobUrlKey: "bank_statement_blob_url",
      // fileKey: "bankStatementFile",
    },
    address_proof: {
      fileNameKey: "address_proof_file_name",
      blobUrlKey: "address_proof_blob_url",
      // fileKey: "addressProofFile",
    },

    id_front: {
      fileNameKey: "id1FrontName",
      blobUrlKey: "id1FrontBlobUrl",
      // fileKey: "idFrontFile",
    },
    id_back: {
      fileNameKey: "id1BackName",
      blobUrlKey: "id1BackBlobUrl",
      // fileKey: "idBackFile",
    },
    id_front2: {
      fileNameKey: "id2FrontName",
      blobUrlKey: "id2FrontBlobUrl",
      // fileKey: "idFront2File",
    },
    id_back2: {
      fileNameKey: "id2BackName",
      blobUrlKey: "id2BackBlobUrl",
      // fileKey: "idBack2File",
    },
  };


  const handleDeleteSelfieFile = async (documentType) => {
    try {
      const investorKycId =
        investorDatauser?.kyc?.[0]?.investor_kyc_id || null;

      if (!investorKycId) return;

      const base = EKYC_BASE_URL;

      getLoadingAlert(LOADING);


      const response = await axios.delete(
        `${base}/ekyc/draft/${investorKycId}/file/${documentType}`,
        {
          params: {
            blob_name: indivInvFormData.selfie_blob_name,
            blob_url: indivInvFormData.selfie_blob_url,
          },
          headers: {
            Authorization: `Bearer ${Cookies.get("User_Accesstoken")}`,
          },
        }
      );

      getLoadingAlert(HIDING);

      // ✅ Clear UI immediately
      setIndivInvFormData((prev) => ({
        ...prev,

        selfie_blob_name: "",
        selfie_blob_url: "",
        liveness_video_blob_name: "",
        liveness_video_blob_url: "",
        livenessSessionId: "",

      }));
    } catch (error) {
      getLoadingAlert(HIDING);

      console.error("Delete file error:", error);
    }
  };


  const handleDeleteFile = async (documentType) => {
    try {
      const investorKycId = investorDatauser?.kyc?.[0]?.investor_kyc_id;
      const base = EKYC_BASE_URL;

      const config = DELETE_DOCUMENT_CONFIG[documentType];
      if (!config) {
        console.error("Invalid document type:", documentType);
        return;
      }

      const blobName = indivInvFormData[config.fileNameKey];
      const blobUrl = indivInvFormData[config.blobUrlKey];

      if (!blobName || !blobUrl) {
        console.warn("No file to delete for:", documentType);
        return;
      }
      getLoadingAlert(LOADING);

      const response = await axios.delete(
        `${base}/ekyc/draft/${investorKycId}/file/${documentType}`,
        {
          params: {
            blob_name: blobName,
            blob_url: blobUrl,
          },
          headers: {
            Authorization: `Bearer ${Cookies.get("User_Accesstoken")}`,
          },
        }
      );

      getLoadingAlert(HIDING);

      // ✅ Clear UI state
      setIndivInvFormData((prev) => ({
        ...prev,
        // [config.fileKey]: "",
        [config.fileNameKey]: "",
        [config.blobUrlKey]: "",
      }));
    } catch (error) {
      getLoadingAlert(HIDING);

      console.error("Delete file error:", error);
    }
  };





  const handleKYCSaveChanges = async () => {
    try {
      const fInvData = new FormData();

      //  Mandatory IDs
      fInvData.append("user_id", investorDatauser.user_id);
      fInvData.append("investor_id", investorDatauser.investor_id);
      fInvData.append("step_count", currentStep);

      if (investorDatauser?.kyc?.length) {
        fInvData.append(
          "investor_kyc_id",
          investorDatauser.kyc[0].investor_kyc_id
        );
      }

      if (!investorDatauser?.kyc?.length && investorDatauser?.created_by) {
        fInvData.append("created_by", investorDatauser.created_by);
      }

      // 🧠 Fields to send (non-date)
      const personalFields = [
        "gender",
        "phone",
        "registered_address",
        "nationality",
        "country",
        "home_country_contact",
        "investor_company_name",
        "country_of_residence",
        "passport_number",

        "description_of_income",
        "sourse_of_fund",
        "nominee_details",
        "nominee_name",
        "nominee_contact",
        "nominee_address",
        "nominee_relationship",
        // "guardian_name",
        // "guardian_address",
        "name_of_employer",
        "country_of_employer",
        "national_id",
        "other_passport_details",
        "committed_principal",
        "is_pep",
        "investor_name",
      ];


      personalFields.forEach((key) => {
        fInvData.append(key, indivInvFormData[key] ?? "");
      });



      const appendDateIfValid = (key, value) => {
        if (!value) return;

        let time = null;

        // already timestamp
        if (typeof value === "number") {
          time = value;
        }
        // Date object
        else if (value instanceof Date) {
          time = value.getTime();
        }
        // string timestamp
        else if (!isNaN(Number(value))) {
          time = Number(value);
        }

        if (time && !isNaN(time)) {
          fInvData.append(key, time);
        }
      };

      fInvData.append("country_of_birth", indivInvFormData.country);

      appendDateIfValid("date_of_birth", indivInvFormData.date_of_birth);
      appendDateIfValid("nominee_dob", indivInvFormData.nominee_dob);


      if (isMinor) {
        fInvData.append("guardian_name", indivInvFormData.guardian_name ?? "");
        fInvData.append("guardian_address", indivInvFormData.guardian_address ?? "");
        appendDateIfValid("guardian_dob", indivInvFormData.guardian_dob);
      } else {
        fInvData.append("guardian_name", "");
        fInvData.append("guardian_address", "");
        fInvData.append("guardian_dob", "");
      }
      appendDateIfValid("passport_expiry_date", indivInvFormData.passport_expiry_date);

      // 💾 Draft flag
      fInvData.append("save_as_draft", "0");
      getLoadingAlert(LOADING);

      const res = await axios.post(
        base_url + "investor-master/update_investor_master",
        fInvData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      getLoadingAlert(HIDING)
      return res.data?.message === "Updated Investor KYC";
    } catch (err) {
      getLoadingAlert(HIDING)
      toast.error("Failed to save Investor details");
      return false;
    }
  };







  const handleFinalSubmit = async () => {
    try {

      const ekycSuccess = await submitEKYC();
      if (!ekycSuccess) return;

      // Update investor master ONCE
      const saved = await handleKYCSaveChanges();
      if (!saved) return;



      //  Mark flow completed
      markKycCompleted();
      Cookies.remove("kyc_currentPage");


      localStorage.removeItem(`indivInvData_${investorDatauser?.user_id}`);

      toast.success("KYC submitted successfully");
    } catch {

      toast.error("Final submission failed");
    }
  };




  const markKycCompleted = () => {
    setCompletedSteps((prev) => {
      const updated = Array.from(
        new Set([...prev, currentStep])
      ).sort((a, b) => a - b);

      sessionStorage.setItem(
        "kyc_completed_steps",
        JSON.stringify(updated)
      );

      return updated;
    });

    clearKycSessionStorage(indivInvFormData?.user_id);
    setCurrentStep(0);
  };


  const buildFileObj = (blobUrl, originalName) => {
    if (!blobUrl) return null;

    return {
      blob_url: blobUrl,
      original_file_name:
        originalName || blobUrl.split("/").pop(),
    };
  };


  const isValidFile = (blobUrl, fileName) => {
    return !!blobUrl && !!fileName;
  };

  const areFilesValid = (f) => {
    return (
      isValidFile(f.id1FrontBlobUrl, f.id1FrontName) &&
      isValidFile(f.id2FrontBlobUrl, f.id2FrontName) &&
      isValidFile(f.selfie_blob_url, f.selfie_blob_name) &&
      isValidFile(f.liveness_video_blob_url, f.liveness_video_blob_name) &&
      isValidFile(f.bank_statement_blob_url, f.bank_statement_file_name)
    )
  };

  const isFormDataValid = (f) => {
    return (
      !!f.investor_name &&
      !!f.country &&
      !!f.idType1 &&
      !!f.idType2
    );
  };

  const isLivenessValid = (f) => {
    return !!f.livenessSessionId;
  };

  const isEKYCReady = () => {
    const f = indivInvFormData;

    return (
      isFormDataValid(f) &&
      areFilesValid(f) &&
      isLivenessValid(f)
    );
  };


  const submitEKYC = async () => {
    try {
      const base = EKYC_BASE_URL;

      const payload = {
        investor_kyc_id: investorDatauser.kyc[0]?.investor_kyc_id,
        user_id: investorDatauser.user_id,
        investor_id: investorDatauser.investor_id,
        created_by: investorDatauser.created_by,



        uploaded_files: Object.fromEntries(
          Object.entries({
            id_front: buildFileObj(
              indivInvFormData.id1FrontBlobUrl,
              indivInvFormData.id1FrontName
            ),

            id_back: buildFileObj(
              indivInvFormData.id1BackBlobUrl,
              indivInvFormData.id1BackName
            ),

            id_front2: buildFileObj(
              indivInvFormData.id2FrontBlobUrl,
              indivInvFormData.id2FrontName
            ),

            id_back2: buildFileObj(
              indivInvFormData.id2BackBlobUrl,
              indivInvFormData.id2BackName
            ),

            selfie: buildFileObj(
              indivInvFormData.selfie_blob_url,
              indivInvFormData.selfie_blob_name
            ),

            liveness_video: buildFileObj(
              indivInvFormData.liveness_video_blob_url,
              indivInvFormData.liveness_video_blob_name
            ),

            bank_statement: buildFileObj(
              indivInvFormData.bank_statement_blob_url,
              indivInvFormData.bank_statement_file_name
            ),

            address_proof: buildFileObj(
              indivInvFormData.address_proof_blob_url,
              indivInvFormData.address_proof_file_name
            ),
          }).filter(([, v]) => v !== null)
        ),


        // 🔹 Liveness
        liveness_session_id: indivInvFormData.livenessSessionId,

        // 🔹 Personal data
        form_data: {
          fullName: indivInvFormData.investor_name,
          country: indivInvFormData.country,
          idType: indivInvFormData.idType1,
          idType2: indivInvFormData.idType2,
        },
      };



      getLoadingAlert(LOADING);

      const res = await axios.post(
        `${base}/ekyc/submit-with-urls`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      getLoadingAlert(HIDING);

      toast.success(
        `eKYC submitted successfully.`
      );

      return true;
    } catch (err) {
      getLoadingAlert(HIDING);
      console.error("eKYC submit error:", err);

      if (err?.response?.status === 422) {
        const details = err.response.data?.error?.details || [];
        details.forEach((d) => {
          toast.error(`${d.loc?.[1] || "field"}: ${d.msg}`);
        });
        return false;
      }

      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong while submitting eKYC"
      );

      return false;
    }
  };






  const handleDeleteClick = (item) => {
    let sample_download = [...download];
    sample_download.forEach((doc) => {
      if (doc.doc_type == item.doc_type) {
        item.is_upload = false;
        doc.is_upload = false;
        doc.document_type = "";
        doc.document_url = "";
        doc.file_name = "";
      }
    });
    setDownload(sample_download);
    handleDeleteDoc(item);
  };

  const handleDeleteDoc = (item) => {
    setDeletedDoc(prevItems => [...prevItems, item.document_id]);
  }



  const handleUpdateKyc = async () => {
    setSaveKYCBtn(true)
    const fData = new FormData();

    let documents_lst = [];

    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          // is_upload: !!eachDoc.document_url
        });
      }
    });
    // const requiredDocuments = [
    //   "ID Proof - National ID",
    //   "6 Months Bank Account Statement"
    // ];


    // const mandatoryDocuments = requiredDocuments.every((type) =>
    //   documents_lst.some((doc) => doc.document_type === type && doc.is_upload)
    // );

    if (Cookies.get("investor_type") === INVESTOR_TYPE_INDIVIDUAL) {

      fData.append('investor_id', rejectedInvDetails?.investor_id);
      fData.append('investor_kyc_id', rejectedInvDetails?.investor_kyc_id);
      fData.append('user_id', rejectedInvDetails?.user_id);
      fData.append('gender', rejectedInvDetails?.gender);
      fData.append('phone', rejectedInvDetails?.phone);
      fData.append('registered_address', rejectedInvDetails?.registered_address);
      fData.append('nationality', rejectedInvDetails?.nationality);
      fData.append('country', rejectedInvDetails?.country);
      fData.append('home_country_contact', rejectedInvDetails?.home_country_contact);
      if (rejectedInvDetails?.date_of_birth) {
        fData.append('date_of_birth', new Date(rejectedInvDetails?.date_of_birth).getTime());
      }
      fData.append('country_of_birth', rejectedInvDetails?.country_of_birth);
      fData.append('passport_number', rejectedInvDetails?.passport_number);
      if (rejectedInvDetails?.passport_expiry_date) {
        fData.append('passport_expiry_date', new Date(rejectedInvDetails?.passport_expiry_date).getTime());
      }
      fData.append('description_of_income', rejectedInvDetails?.description_of_income);
      fData.append('sourse_of_fund', rejectedInvDetails?.sourse_of_fund);
      fData.append('nominee_details', rejectedInvDetails?.nominee_details);
      fData.append('name_of_employer', rejectedInvDetails?.name_of_employer);
      fData.append('country_of_employer', rejectedInvDetails?.country_of_employer);
      fData.append('national_id', rejectedInvDetails?.national_id);
      fData.append('other_passport_details', rejectedInvDetails?.other_passport_details);
      fData.append('committed_principal', rejectedInvDetails?.committed_principal);
      fData.append('is_pep', rejectedInvDetails?.is_pep);
      fData.append('status', statusFlag)
      fData.append('save_as_draft', '0');
      fData.append("deleted_doc", deletedDoc);


    } else {
      for (let i = 0; i < rejectedCustomers.length; i++) {
        if (rejectedCustomers !== undefined) { fData.append('top_5_customers', rejectedCustomers[i]) };
      }
      for (let i = 0; i < rejectedSuppliers.length; i++) {
        if (rejectedSuppliers[i] !== undefined) { fData.append('top_5_suppliers', rejectedSuppliers[i]) };
      }
      // for (let i = 0; i < rejectedBanks.length; i++) {
      //   if(rejectedBanks[i]!==undefined){fData.append('banks_list', rejectedBanks[i])}
      // }

      fData.append('investor_id', rejectedInvDetails?.investor_id);
      fData.append('investor_kyc_id', rejectedInvDetails?.investor_kyc_id);
      fData.append('user_id', rejectedInvDetails?.user_id);
      fData.append('investor_company_type', rejectedInvDetails?.investor_company_type);
      fData.append('phone', rejectedInvDetails?.phone);
      fData.append('country', rejectedInvDetails?.country);
      fData.append('sector', rejectedInvDetails?.sector);
      fData.append('registered_address', rejectedInvDetails?.registered_address);
      fData.append('place_of_incorporation', rejectedInvDetails?.place_of_incorporation);
      if (rejectedInvDetails?.date_of_incorporation) {
        fData.append('date_of_incorporation', new Date(rejectedInvDetails?.date_of_incorporation).getTime());
      }
      fData.append('trade_license_no', rejectedInvDetails?.trade_license_no);
      if (rejectedInvDetails?.trade_license_expiry_date !== '') {
        fData.append('trade_license_expiry_date', new Date(rejectedInvDetails?.trade_license_expiry_date).getTime());
      }
      fData.append('description_of_business', rejectedInvDetails?.description_of_business);
      fData.append('beneficial_owner_with_percentage_holding', rejectedInvDetails?.beneficial_owner_with_percentage_holding);
      fData.append('shareholders', JSON.stringify(rejectedShareHolderData));
      fData.append('products_by_the_company', rejectedInvDetails?.products_by_the_company);
      fData.append('origin_of_products', rejectedInvDetails?.origin_of_products);
      fData.append('import_countries_with_percentage', rejectedInvDetails?.import_countries_with_percentage);
      fData.append('export_countries_with_percentage', rejectedInvDetails?.export_countries_with_percentage);
      fData.append('re_export_countries_with_percentage', rejectedInvDetails?.re_export_countries_with_percentage);
      if (rejectedInvDetails?.no_of_full_time_employees) { fData.append('no_of_full_time_employees', rejectedInvDetails?.no_of_full_time_employees) };
      fData.append('committed_principal', rejectedInvDetails?.committed_principal);
      fData.append('is_pep', rejectedInvDetails?.is_pep);
      fData.append("deleted_doc", deletedDoc);
      fData.append('save_as_draft', '0');
    }
    documents_lst.forEach(elem => {
      if (elem.document_url) {
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
        if (elem.document_type === "Others") {
          fData.append('file_name', fileName);
        }
      }
    })
    if ((Cookies.get("investor_type") === INVESTOR_TYPE_COMPANY) &&
      (rejectedInvDetails?.sector == '' ||
        rejectedInvDetails?.country == '' ||
        rejectedInvDetails?.registered_address == '' ||
        rejectedInvDetails?.investor_company_type == '' ||
        rejectedInvDetails?.phone == '' ||
        rejectedInvDetails?.committed_principal == '' ||
        rejectedInvDetails?.place_of_incorporation == '' ||
        rejectedInvDetails?.description_of_business == '' ||
        rejectedInvDetails?.beneficial_owner_with_percentage_holding == '' ||
        rejectedInvDetails?.date_of_incorporation == '' ||
        rejectedInvDetails?.trade_license_expiry_date == '' ||
        rejectedInvDetails?.products_by_the_company == '' ||
        rejectedInvDetails?.origin_of_products == '' ||
        rejectedInvDetails?.import_countries_with_percentage == '' ||
        rejectedInvDetails?.export_countries_with_percentage == '' ||
        rejectedInvDetails?.re_export_countries_with_percentage == '' ||
        rejectedInvDetails?.no_of_full_time_employees == '' ||
        rejectedInvDetails?.is_pep == ''
      )

    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 38,
      });
      setSaveKYCBtn(false)
    }
    // else if(!mandatoryDocuments){
    //   toast.error("Please upload mandatory documents", {
    //     toastId: 380,
    //   });
    // }
    else if ((Cookies.get("investor_type") === INVESTOR_TYPE_INDIVIDUAL) &&
      (
        // !rejectedInvDetails.gender||
        //  !indivInvFormData.country||
        // !rejectedInvDetails?.registered_address||
        // !rejectedInvDetails?.committed_principal||
        // !rejectedInvDetails?.phone||
        // !rejectedInvDetails?.investor_company_type ||
        // !rejectedInvDetails?.date_of_birth ||
        // !rejectedInvDetails?.country_of_birth ||
        // !rejectedInvDetails?.country 




        !rejectedInvDetails?.committed_principal ||
        !rejectedInvDetails?.country ||
        !rejectedInvDetails?.country_of_birth ||
        !rejectedInvDetails?.country_of_employer ||
        !rejectedInvDetails?.date_of_birth ||
        !rejectedInvDetails?.description_of_income ||
        !rejectedInvDetails?.nationality ||
        !rejectedInvDetails.gender ||
        !rejectedInvDetails?.is_pep ||
        !rejectedInvDetails?.name_of_employer ||
        !rejectedInvDetails?.national_id ||
        !rejectedInvDetails?.nominee_details ||
        !rejectedInvDetails?.passport_expiry_date ||
        !rejectedInvDetails?.passport_number ||
        !rejectedInvDetails?.registered_address ||
        !rejectedInvDetails?.sourse_of_fund ||
        !rejectedInvDetails?.phone


      )) {

      toast.error("Please fill out mandatory fields", {
        toastId: 98,
      });
      setSaveKYCBtn(false)
    }
    else {
      const response = await axios.post(base_url + "investor-master/update_investor_kyc", fData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.message === 'Updated Investor KYC') {
        toast.success("Submitted Successfully", {
          toastId: 42,
        });
        setTimeout(() => {
          window.location.reload();
        }, 800);
      }

      else {

        setSaveKYCBtn(false)
        alert("Something went wrong")

      }
    }
    // ======end======
  }


  const decodeFileName = (value = "") => {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  };


  const mapDocumentsToState = (documents = [], draftFiles = {}) => {
    const mapped = {};

    documents.forEach((doc) => {
      const url = doc.document_url;
      const rawFileName = doc.original_file_name


      switch (doc.document_type) {

        case "3 Months Bank Account Statement":

          if (draftFiles.bank_statement !== undefined) return;
          mapped.bank_statement_blob_url = url;
          mapped.bank_statement_file_name = decodeFileName(rawFileName);
          break;


        case "ID Proof - Address Proof":
          if (draftFiles.address_proof !== undefined) return;

          mapped.address_proof_blob_url = url;
          mapped.address_proof_file_name = decodeFileName(rawFileName);
          break;

        // case "Photograph":
        //   if (draftFiles.selfie !== undefined) return;

        //   mapped.selfie_blob_url = url;
        //   mapped.selfie_blob_name = decodeFileName(rawFileName);
        //   break;

        case "Photograph": {
          const isApproved =
            investorDatauser?.kyc?.[0]?.status === COMPLIANCE_APPROVED;

          if (isApproved) {
            mapped.selfie_blob_url = url;
            mapped.selfie_blob_name = decodeFileName(rawFileName);
            break;
          }

          if (draftFiles.selfie !== undefined) return;

          mapped.selfie_blob_url = url;
          mapped.selfie_blob_name = decodeFileName(rawFileName);
          break;
        }

        case "Others - Selfie Video":
          if (draftFiles.liveness_video !== undefined) return;

          mapped.liveness_video_blob_url = url;
          mapped.liveness_video_blob_name = decodeFileName(rawFileName);
          break;

        case "ID Proof 1 - National ID - Front":
          if (draftFiles.id_front !== undefined) return;

          mapped.id1FrontBlobUrl = url;
          mapped.id1FrontName = decodeFileName(rawFileName);
          break;

        case "ID Proof 1 - National ID - Back":
          if (draftFiles.id_back !== undefined) return;

          mapped.id1BackBlobUrl = url;
          mapped.id1BackName = decodeFileName(rawFileName);
          break;

        case "ID Proof 2 - National ID - Front":
          if (draftFiles.id_front2 !== undefined) return;
          mapped.id2FrontBlobUrl = url;
          mapped.id2FrontName = decodeFileName(rawFileName);
          break;

        case "ID Proof 2 - National ID - Back":
          if (draftFiles.id_back2 !== undefined) return;
          mapped.id2BackBlobUrl = url;
          mapped.id2BackName = decodeFileName(rawFileName);
          break;

        case "ID Proof 1 - Passport - Front":
          if (draftFiles.id_front !== undefined) return;
          mapped.id1FrontBlobUrl = url;
          mapped.id1FrontName = decodeFileName(rawFileName);
          break;

        case "ID Proof 1 - Passport - Back":
          if (draftFiles.id_back !== undefined) return;
          mapped.id1BackBlobUrl = url;
          mapped.id1BackName = decodeFileName(rawFileName);
          break;

        case "ID Proof 2 - Passport - Front":
          if (draftFiles.id_front2 !== undefined) return;
          mapped.id2FrontBlobUrl = url;
          mapped.id2FrontName = decodeFileName(rawFileName);
          break;

        case "ID Proof 2 - Passport - Back":
          if (draftFiles.id_back2 !== undefined) return;
          mapped.id2BackBlobUrl = url;
          mapped.id2BackName = decodeFileName(rawFileName);
          break;

        case "ID Proof 1 - Other Government Issued ID - Front":
          if (draftFiles.id_front !== undefined) return;
          mapped.id1FrontBlobUrl = url;
          mapped.id1FrontName = decodeFileName(rawFileName);
          break;

        case "ID Proof 1 - Other Government Issued ID - Back":
          if (draftFiles.id_back !== undefined) return;
          mapped.id1BackBlobUrl = url;
          mapped.id1BackName = decodeFileName(rawFileName);
          break;

        case "ID Proof 2 - Other Government Issued ID - Front":
          if (draftFiles.id_front2 !== undefined) return;
          mapped.id2FrontBlobUrl = url;
          mapped.id2FrontName = decodeFileName(rawFileName);
          break;

        case "ID Proof 2 - Other Government Issued ID - Back":
          if (draftFiles.id_back2 !== undefined) return;
          mapped.id2BackBlobUrl = url;
          mapped.id2BackName = decodeFileName(rawFileName);
          break;

        default:
          break;
      }
    });
    // console.log('mapped', mapped)
    return mapped;
  };


  useEffect(() => {
    if (!masterInvestorData?.kycData) return;

    const saved = localStorage.getItem(`indivInvData_${investorDatauser?.user_id}`);
    const localData = saved ? JSON.parse(saved) : {};

    const documentState = mapDocumentsToState(
      masterInvestorData?.documents || [],
      draftFiles
    );

    const ekycInputs = masterInvestorData?.ekycChecks?.inputs || {};


    const livenessSessionIddd =
      masterInvestorData?.ekycChecks?.livenessSessionId;

    const hasDraft =
      draftFiles &&
      Object.keys(draftFiles).length > 0;

    setIndivInvFormData(prev => {

      const apiData = {
        ...masterInvestorData.investorData,
        ...masterInvestorData.kycData,
      };


      const getValue = (localVal, apiVal) =>
        localVal ? localVal : (apiVal || "");

      const next = {
        ...prev,
        ...apiData,
        ...documentState,



        investor_name: getValue(localData.investor_name, apiData.investor_name),
        phone: getValue(localData.phone, apiData.phone),
        email: getValue(localData.email, apiData.email),
        date_of_birth: getValue(localData.date_of_birth, apiData.date_of_birth),
        country: getValue(localData.country, apiData.country),
        nationality: getValue(localData.nationality, apiData.nationality),
        country_of_residence: getValue(localData.country_of_residence, apiData.country_of_residence),
        name_of_employer: getValue(localData.name_of_employer, apiData.name_of_employer),
        sourse_of_fund: getValue(localData.sourse_of_fund, apiData.sourse_of_fund),
        committed_principal: getValue(localData.committed_principal, apiData.committed_principal),
        gender: getValue(localData.gender, apiData.gender),
        investor_company_name: getValue(localData.investor_company_name, apiData.investor_company_name),

        nominee_name: getValue(localData.nominee_name, apiData.nominee_name),
        nominee_relationship: getValue(localData.nominee_relationship, apiData.nominee_relationship),
        nominee_dob: getValue(localData.nominee_dob, apiData.nominee_dob),
        nominee_contact: getValue(localData.nominee_contact, apiData.nominee_contact),

        guardian_name: getValue(localData.guardian_name, apiData.guardian_name),
        guardian_address: getValue(localData.guardian_address, apiData.guardian_address),
        guardian_dob: getValue(localData.guardian_dob, apiData.guardian_dob),

        is_pep: getValue(localData.is_pep, apiData.is_pep),

      };

      if (!hasDraft) {
        next.idType1 = ekycInputs.idType ?? prev.idType1;
        next.idType2 = ekycInputs.idType2 ?? prev.idType2;

        next.livenessSessionId =
          livenessSessionIddd || prev.livenessSessionId;
      }

      // console.log('next', next)
      return next;
    });

  }, [masterInvestorData, draftFiles]);


  useEffect(() => {
    if (!investorKycId || draftLoaded) return;


    const loadDraft = async () => {
      const draft = await getDraft(investorKycId);
      if (!draft?.has_draft) {
        setDraftLoaded(true);
        return;
      }

      const restoredForm = {
        ...draft.form_data,

        idType: draft.form_data?.idType ?? "",
        idType2: draft.form_data?.idType2 ?? "",
        idType1: draft.form_data?.idType ?? "",
      };

      const files = draft.uploaded_files || {};


      const requiresNew = draft.requires_new_selfie_liveness;
      const message = draft.selfie_liveness_message;


      const isPendingSubmittedFlow =
        investorDatauser?.kyc?.[0]?.save_as_draft === 0 &&
        statusFlagValue === COMPLIANCE_PENDING;

      const isApprovedFlow =
        investorDatauser?.kyc?.[0]?.status === COMPLIANCE_APPROVED;

      const shouldBlockMessage = isPendingSubmittedFlow || isApprovedFlow;

      if (requiresNew && !shouldBlockMessage) {
        setLivenessErrorMsg(
          message || "Please take a new selfie and complete liveness again before submitting."
        );
        toast.error(message || "Please take a new selfie and complete liveness again before submitting.", {
          autoClose: 5000, //  5 seconds
        });
      } else {

        setLivenessErrorMsg("");
      }


      // Bank
      if (files.bank_statement) {
        restoredForm.bank_statement_blob_url = files.bank_statement.blob_url;
        restoredForm.bank_statement_file_name = files.bank_statement.original_file_name || files.bank_statement.original_name;
      }

      // Address
      if (files.address_proof) {
        restoredForm.address_proof_blob_url = files.address_proof.blob_url;
        restoredForm.address_proof_file_name = files.address_proof.original_file_name || files.address_proof.original_name;
      }

      // IDs
      if (files.id_front) {
        restoredForm.id1FrontBlobUrl = files.id_front.blob_url;
        restoredForm.id1FrontName = files.id_front.original_file_name || files.id_front.original_name;

      }

      if (files.id_back) {
        restoredForm.id1BackBlobUrl = files.id_back.blob_url;
        restoredForm.id1BackName = files.id_back.original_file_name || files.id_back.original_name;

      }

      if (files.id_front2) {
        restoredForm.id2FrontBlobUrl = files.id_front2.blob_url;
        restoredForm.id2FrontName = files.id_front2.original_file_name || files.id_front2.original_name;

      }

      if (files.id_back2) {
        restoredForm.id2BackBlobUrl = files.id_back2.blob_url;
        restoredForm.id2BackName = files.id_back2.original_file_name || files.id_back2.original_name;

      }

      // Selfie & liveness



      if (!requiresNew) {
        // ✅ restore only if allowed
        if (files.selfie) {
          restoredForm.selfie_blob_url = files.selfie.blob_url;
          restoredForm.selfie_blob_name = files.selfie.original_file_name || files.selfie.original_name;
        }

        if (files.liveness_video) {
          restoredForm.liveness_video_blob_url = files.liveness_video.blob_url;
          restoredForm.liveness_video_blob_name = files.liveness_video.original_file_name || files.liveness_video.original_name;
        }

        restoredForm.livenessSessionId = draft.liveness_session_id ?? null;
      } else {
        //  DO NOT restore
        restoredForm.livenessSessionId = null;
      }

      // console.log('restoredForm',restoredForm)

      //  ONE state update only
      setIndivInvFormData((prev) => ({
        ...prev,
        ...restoredForm,
      }));


      setDraftFiles({
        bank_statement: !!files.bank_statement,
        address_proof: !!files.address_proof,
        id_front: !!files.id_front,
        id_back: !!files.id_back,
        id_front2: !!files.id_front2,
        id_back2: !!files.id_back2,

        idType: !!draft.form_data?.idType,
        idType1: !!draft.form_data?.idType,
        idType2: !!draft.form_data?.idType2,

        selfie: !!files.selfie && !requiresNew,
        liveness_video: !!files.liveness_video && !requiresNew,
        livenessSessionId: !!draft.liveness_session_id && !requiresNew,

      });


      setUploadedFiles(files);
      setLivenessSessionId(
        requiresNew ? null : draft.liveness_session_id ?? null
      );

      setDraftLoaded(true);
    };

    loadDraft();
  }, [investorKycId]);


  const loadDraftClick = async () => {
    if (!investorKycId) return;

    const draft = await getDraft(investorKycId);
    if (!draft?.has_draft) {
      setDraftLoaded(true);
      return;
    }

    const restoredForm = {
      ...draft.form_data,
      idType: draft.form_data?.idType ?? "",
      idType1: draft.form_data?.idType ?? "",
      idType2: draft.form_data?.idType2 ?? "",
    };

    const files = draft.uploaded_files || {};

    const requiresNew = draft.requires_new_selfie_liveness;
    const message = draft.selfie_liveness_message;

    const isPendingSubmittedFlow =
      investorDatauser?.kyc?.[0]?.save_as_draft === 0 &&
      statusFlagValue === COMPLIANCE_PENDING;

    const isApprovedFlow =
      investorDatauser?.kyc?.[0]?.status === COMPLIANCE_APPROVED;

    const shouldBlockMessage = isPendingSubmittedFlow || isApprovedFlow;

    if (requiresNew && !shouldBlockMessage) {



      // if (requiresNew && shouldBlockMessage) {

      setLivenessErrorMsg(
        message || "Please take a new selfie and complete liveness again before submitting."
      );
    } else {

      setLivenessErrorMsg("");
    }

    setIndivInvFormData(prev => ({
      ...prev,
      ...restoredForm
    }));

    setDraftFiles({
      bank_statement: !!files.bank_statement,
      address_proof: !!files.address_proof,
      id_front: !!files.id_front,
      id_back: !!files.id_back,
      id_front2: !!files.id_front2,
      id_back2: !!files.id_back2,
      // selfie: !!files.selfie,
      // liveness_video: !!files.liveness_video,
      idType: !!draft.form_data?.idType,
      idType1: !!draft.form_data?.idType,
      idType2: !!draft.form_data?.idType2,
      // livenessSessionId: !!draft.liveness_session_id,
      selfie: !!files.selfie && !requiresNew,
      liveness_video: !!files.liveness_video && !requiresNew,
      livenessSessionId: !!draft.liveness_session_id && !requiresNew,
    });

    setUploadedFiles(files);
    setLivenessSessionId(
      requiresNew ? null : draft.liveness_session_id ?? null
    );

    setDraftLoaded(true);
  };



  useEffect(() => {
    setCompanyFormData(masterInvestorData);
  }, [masterInvestorData])



  const clearKycSessionStorage = async (userId) => {


    if (!userId) return;

    const keysToRemove = [


      "kyc_selfie_preview",
      "kyc_completed_steps",
      "kyc_current_step",
    ];

    keysToRemove.forEach((key) => {
      sessionStorage.removeItem(key);
    });
  };



  const statusFlagValue = investorDatauser?.kyc?.[0]?.status;
  const isApproved = statusFlagValue === COMPLIANCE_APPROVED;




  return (
    <>







      {Cookies.get("investor_type") === INVESTOR_TYPE_COMPANY ?
        <>
          <div style={{ display: 'flex', }}>
            <InvestorSideNavBar kycstatus={investorDatauser}
              currentStep={currentStep}
            />
            <main style={{ width: "100%" }}>
              <InvestorNavBarMain />

              <div className="pt-3 pb-0 p-4 pagestyle">
                <div className=" d-flex  align-items-center ">
                  <h1 className="mb-0">KYC FORM</h1>
                </div>

                <div className="settingsmaindiv">
                  <div className="">
                    <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv active p-1"
                          id="BasicDetails-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#BasicDetails-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="BasicDetails-tab-pane"
                          aria-selected="true"
                        >
                          <h3>Form Detail </h3>
                        </button>
                        {investorDatauser?.kyc?.length === 0 && <span className="text-danger fs-6">Status: Please fill the KYC Form </span>}
                        {investorDatauser?.kyc?.length > 0 && investorDatauser?.kyc[0]?.status === COMPLIANCE_PENDING && <span className="text-danger fs-6">Status: Under Review</span>}
                        {investorDatauser?.kyc?.length > 0 && investorDatauser?.kyc[0]?.status === COMPLIANCE_REJECTED && <span className="text-danger fs-6">Status: Rejected</span>}
                        {investorDatauser?.kyc?.length > 0 && investorDatauser?.kyc[0]?.status === COMPLIANCE_APPROVED && <span className="text-danger fs-6">{investorDatauser?.kyc[0]?.kyc_expiry_date < new Date().getTime() ? "KYC expired on" : "KYC Approved- Expiry Date"} : {moment(investorDatauser?.kyc[0]?.kyc_expiry_date).format("DD-MMM-YYYY")}{(investorDatauser?.kyc[0]?.kyc_expiry_date) < (new Date().getTime()) ? ". Please fill the KYC form" : ""}</span>}
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content " id="myTabContent">
                    <div
                      className="tab-pane fade show active "
                      id="BasicDetails-tab-pane"
                      role="tabpanel"
                      aria-labelledby="BasicDetails-tab"
                      tabIndex="0"
                    >
                      <BusinessSettings
                        others={others}
                        rejectedShareHolderData={rejectedShareHolderData}
                        handleAddRow={handleAddRow}
                        plusDisabled={plusDisabled}
                        shareHolderData={shareHolderData}
                        masterData={masterInvestorData}
                        dataUser={investorDatauser}
                        defaultvalue={defaultvalue}
                        handleRemoveRow={handleRemoveRow}
                        statusFlag={statusFlag}
                        handleFieldChange={handleFieldChange}
                        rejectedDetails={rejectedInvDetails}
                        formData={companyFormData}
                        rejectedFlag={rejectedFlag}
                        rejectedCustomers={rejectedCustomers}
                        getDocuments={getDocuments}
                        handleCustomerChange={handleCustomerChange}
                        updatedCustomers={updatedCustomers}
                        rejectedSuppliers={rejectedSuppliers}
                        handleSupplierChange={handleSupplierChange}
                        updatedSuppliers={updatedSuppliers}
                        handleInputChange={handleInputChange}
                        download={download}
                        handleChange={handleChange}
                        handleChangeDownload={handleChangeDownload}
                        saveKYCBtn={saveKYCBtn}
                        handleSubmit={handleSubmit}
                        handleSavechanges={handleSavechanges}
                        handleUpdateKyc={handleUpdateKyc}
                        handleDeleteClick={handleDeleteClick}
                        handleSaveDraftCompany={handleSaveDraftCompany}
                        mergedDownloads={mergedDownloads}
                        handleIsDataNull={isDataNull}
                        handleDeleteClickOthers={handleDeleteClickOthers}
                        handleChangeDownloadForOthers={handleChangeDownloadForOthers}
                        handleBankChange={handleBankChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

            </main>
          </div>
        </>
        :
        <>

          <div className="kyc-layout">

            {/* {(showInvestorSidebar && !isKycExpiry) ? ( */}
            {(showInvestorSidebar) ? (

              <InvestorSideNavBar
                kycstatus={investorDatauser}
                currentStep={currentStep}
              />
            ) : (
              <Sidebar
                width="343px"
                collapsedWidth="80px"
                className="sidebarprohead"
              >
                <span onClick={() => collapseSidebar()}>
                  {collapsed ? (
                    <img
                      src="./images/bean_logo.svg"
                      alt="logo"
                      className="sidebarimg"
                    />
                  ) : (
                    <img
                      src="./images/New_white_blue_brand_name.svg"
                      alt="logo"
                      className="brand_logo_styl"
                    />
                  )}
                </span>

                <SideNavBarInvestorKYC
                  currentStep={currentStep}
                  completedSteps={completedSteps}
                />
              </Sidebar>
            )}




            {/* RIGHT CONTENT - scrollable */}

            <div className="right-panel">

              <InvestorNavBarMain />

              {/* {(!isApproved && !isKycExpiry) && currentStep > 0 && currentStep <= 5 && ( */}

              {(!isApproved) && currentStep > 0 && currentStep <= 5 && (

                <div className="kyc-progress-wrapper">
                  <ProgressBar currentStep={currentStep} />
                </div>
              )}



              <div className="kyc-content" ref={contentRef}>

                {!isKycReady ? (

                  <div className="historyLoader">
                    <ThreeDots
                      height="70"
                      width="70"
                      radius="9"
                      color="#3D79F3"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  </div>
                ) : (
                  <>

                    <GlobalLoader show={enableSweetAlert} />
                    {currentStep === 1 && (
                      <InvestorContactDetails


                        indivInvFormData={indivInvFormData}
                        investorDatauser={investorDatauser}
                        handleFieldChange={handleFieldChange}
                        onNext={() => goToNextStep(2)}
                        setValidateErrors={setValidateErrors}
                        validateErrors={validateErrors}
                        removeCompletedStep={removeCompletedStep}
                        handleSaveKYCDraft={handleSaveKYCDraft}

                      />
                    )}

                    {currentStep === 2 && (
                      <InvestorPersonalDetails

                        indivInvFormData={indivInvFormData}
                        handleBankStatementChange={handleBankStatementChange}
                        handleFieldChange={handleFieldChange}
                        onNext={() => goToNextStep(3)}
                        onBack={() => goToPreviousStep(1)}
                        setValidatePersonalErrors={setValidatePersonalErrors}
                        validatePersonalErrors={validatePersonalErrors}
                        bankStatementError={bankStatementError}
                        setBankStatementError={setBankStatementError}
                        removeCompletedStep={removeCompletedStep}
                        handleSaveKYCDraft={handleSaveKYCDraft}
                        handleViewFile={handleViewFile}
                        handleDeleteFile={handleDeleteFile}
                        investorDatauser={investorDatauser}



                      />
                    )}

                    {currentStep === 3 && (
                      <InvestorIdentityVerification
                        indivInvFormData={indivInvFormData}
                        handleFieldChange={handleFieldChange}
                        onNext={() => goToNextStep(4)}
                        onBack={() => goToPreviousStep(2)}
                        setValidateIdErrors={setValidateIdErrors}
                        validateIdErrors={validateIdErrors}
                        removeCompletedStep={removeCompletedStep}
                        handleIdentityChange={handleIdentityChange}
                        identityError={identityError}
                        setIdentityError={setIdentityError}
                        handleSaveKYCDraft={handleSaveKYCDraft}
                        setIndivInvFormData={setIndivInvFormData}
                        handleViewFile={handleViewFile}
                        handleDeleteFile={handleDeleteFile}
                        setUploadedFiles={setUploadedFiles}
                        saveDraft={saveDraft}
                        getFormData={getFormData}
                        livenessSessionId={livenessSessionId}
                        currentStep={currentStep}
                        investorKycId={investorKycId}
                        investorDatauser={investorDatauser}

                      />
                    )}

                    {currentStep === 4 && (
                      <InvestorSelfieCapture
                        indivInvFormData={indivInvFormData}
                        onNext={() => goToNextStep(5)}
                        onBack={() => goToPreviousStep(3)}
                        setSelfieData={setSelfieData}
                        selfieData={selfieData}
                        removeCompletedStep={removeCompletedStep}
                        handleSelfieAndLivenessChange={handleSelfieAndLivenessChange}
                        setShowSelfieModal={setShowSelfieModal}
                        showSelfieModal={showSelfieModal}
                        setIsSelfieDone={setIsSelfieDone}
                        isSelfieDone={isSelfieDone}
                        handleSaveKYCDraft={handleSaveKYCDraft}
                        handleViewFile={handleViewFile}
                        handleDeleteSelfieFile={handleDeleteSelfieFile}
                        investorDatauser={investorDatauser}
                        livenessErrorMsg={livenessErrorMsg}


                      />
                    )}


                    {currentStep === 5 && (
                      <>

                        <InvestorReviewDetails

                          indivInvFormData={indivInvFormData}
                          investorDatauser={investorDatauser}
                          onEditStep={(step) => setCurrentStep(step)}
                          onNext={handleFinalSubmit}
                          onBack={() => goToPreviousStep(4)}
                          handleViewFile={handleViewFile}
                          removeCompletedStep={removeCompletedStep}
                          isEKYCReady={isEKYCReady}
                          setCurrentStep={setCurrentStep}



                        />
                      </>
                    )}
                    {/* {(investorDatauser?.kyc?.[0]?.save_as_draft === 0 && statusFlag === COMPLIANCE_PENDING) && ( */}

                    {currentStep === 0 && (

                      <div className="kyc-poppins-ui">
                        <div className="success-wrapper">
                          <div className="success-card">
                            {/* Icon */}
                            <div className="success-icon-circle">
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                  fill="#ffffff"
                                />
                              </svg>
                            </div>

                            {/* Title */}
                            <h2 className="success-title">
                              Application Submitted Successfully! 🎉
                            </h2>

                            {/* Message */}
                            <p className="success-message">
                              Thank you for completing your KYC verification with BenneFin.
                              We’ll review your application and get back to you within
                              <strong> 24–48 hours</strong>.
                            </p>

                            {/* Info box */}
                            <div className="success-info-box">
                              <h4>What’s next?</h4>
                              <ul>
                                <li>You’ll receive a confirmation email shortly.</li>
                                <li>Our compliance team will verify your documents.</li>
                                <li>Once approved, you can start investing confidently.</li>
                              </ul>
                            </div>

                            {/* Footer */}
                            <p className="success-footer">
                              Questions? Contact us at{" "}
                              <a href="mailto:support@bennefin.com">support@bennefin.com</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                  </>
                )}
                {/* {currentStep === null && <GlobalLoader />} */}


              </div>
            </div>
          </div>
        </>
      }







    </>
  );
};

export default InvestorKYCFlow;
